// zh_CN.js
import React from "react";
const vi_VN = {
    "ZHONGWEN":"Chinese",
    "YINGYU":"English",
    "XIBANYAYU":"Español",
    "DEYU":"Deutsch",
    "FAYU":"Français",
    "ALABOYU":"العربية",
    "EYU":"Русский",
    "MALAIYU":"Bahasa Malaysia",
    "YUENANYU":"Tiếng Việt",
    "TAIYU":"ภาษาไทย",
    "YINNIYU":"Bahasa Indonesia",
//components
    "XiaDanTiXing":"Nhắc nhở đặt hàng",
    "NH_GDDBH_":"Xin chào, đơn hàng này chứa sản phẩm \"giá ước tính\", cần chờ khách hàng xác nhận báo giá trước khi thanh toán, có chắc chắn muốn đặt hàng không",
    "QueRenXiaDan":"Xác nhận đặt hàng",
    "WoZaiKanKan":"Tôi xem lại",
    "XSQBDZ": "Hiển thị tất cả địa chỉ",
//ChatRoom
    "ZBZCBQFH": "Tạm không hỗ trợ biểu tượng cảm xúc",
    "FaSongLianJie": "Gửi liên kết",
    "YiChangXiaoXi": "Thông báo bất thường",
    "QingShuRu": "Vui lòng nhập",
    "FaSong": "Gửi",
//DateSelector
    "DQSJXYKSSJ": "Thời gian hiện tại nhỏ hơn thời gian bắt đầu",
    "DQSJCGJSSJ": "Thời gian hiện tại vượt quá thời gian kết thúc",
    "QuXiao": "Hủy",
    "NianYueRi": "Năm tháng ngày",
    "ShiFen": "Giờ phút",
    "QueDing": "Xác nhận",
    "Nian": "năm",
    "Yue": "tháng",
    "Ri": "ngày",
    "Shi": "giờ",
    "Fen": "phút",
//goods-list-card
    "Qi": "từ",
//goods-promotion
    "1GeCuXiao": "1 chương trình khuyến mãi",
    "ChaKanZengPin": "Xem sản phẩm tặng",
    "JHDJSHS_1T": "Còn lại cho đến khi kết thúc hoạt động: {d} ngày {h} giờ {m} phút {s} giây",
    "YHGZ_ZPBKD": "Quy tắc khuyến mãi: Sản phẩm tặng không được叠加获取",
    "YHGZ_AZZGM": "Quy tắc khuyến mãi:享受 ưu đãi theo số lượng mua cuối cùng",
    "GuanBi": "Đóng",
//group-filtrate
    "QuanBu": "Tất cả",
    "ZWXGSJ": "Không có dữ liệu liên quan",
    "ZuiDiJia": "Giá thấp nhất",
    "ZuiGaoJia": "Giá cao nhất",
    "LeiXing": "Loại",
    "PinPai": "Thương hiệu",
    "BiaoQian": "Nhãn",
    "JiaGeQuJian": "Khoảng giá",
    "SPMC_GG_BH_": "Tên sản phẩm / Quy cách / Mã số / Chữ cái đầu tiên",
    "ZuHeShaiXuan": "Lọc kết hợp",
    "ChongZhi_CanShu": "Đặt lại",
//image-upload
    "ZDKSC1ZTP": "Tối đa có thể tải lên {num} ảnh",
    "ZYXSCTP": "Chỉ cho phép tải lên ảnh",
    "SCTPDXBYXC": "Kích thước ảnh tải lên không được vượt quá {size}",
    "QBYCFSCTP_": "Vui lòng không tải lại ảnh trùng lặp, hoặc đảm bảo tên ảnh là duy nhất",
    "ShangChuanChengGong": "Tải lên thành công",
    "ZDKSC1Z": "Tối đa có thể tải lên {num} tấm",
//keyboard
    "CCSLZDXZ": "Vượt quá giới hạn lớn nhất của số lượng",
    "QiDingLiang": "Lượng đặt tối thiểu",
    "ShouQi": "Thu gọn",
    "ShanChu": "Xóa",
//MultiPicker
    "FanHui": "Quay lại",
//order-cart
    "Dai": "Đại",
    "YiQuXiao": "Đã hủy",
    "ZengPin": "Sản phẩm tặng",
    "1Zhong": "{num} loại",
    "1Jian": "1 sản phẩm",
    "HeJi": "Tổng cộng",
    "DaiFu": "Chờ thanh toán",
//order-promotion
    "_DDM1YZ1J_": "【Đơn hàng đủ {targetPrice} đồng tặng {presentNum} sản phẩm】",
    "_DDM1YLJ1Y_": "【Đơn hàng đủ {targetPrice} đồng giảm ngay {price} đồng】",
    "_DDM1YLX1Z_": "【Đơn hàng đủ {targetPrice} đồng享 ngay {discount}折】",
    "DingDanCuXiao": "Khuyến mãi đơn hàng",
//page-ad
    "DLCKJG": "Đăng nhập để xem giá",
//page-floating
    "DianPuZhuYe": "Trang chủ cửa hàng",
    "GouWuChe": "Giỏ hàng",
    "ZaiXianKeFu": "Hỗ trợ trực tuyến",
    "GeRenZhongXin": "Trung tâm cá nhân",
    "LianXiDianHua": "Số điện thoại liên hệ",
    "FanHuiDingBu": "Quay lại đầu trang",
//page-null
    "ZBDYML": "Không tìm thấy trang",
    "KNWZCW_HZY": "Có thể URL sai, hoặc trang đã bị xóa",
    "FanHuiShangJi": "Quay lại trang trên",
    "FanHuiShouYe": "Quay lại trang chủ",
//product-edit
    "SPQDBNWK": "Danh sách sản phẩm không được để trống",
    "WoZhiDaoLe": "Tôi biết rồi",
    "SFQRSCSP": "Có chắc chắn muốn xóa sản phẩm không",
    "QueRen": "Xác nhận",
    "ZYXSRSZBQB": "Chỉ cho phép nhập số và không quá 2 chữ số thập phân",
    "ShangPinDanJia": "Đơn giá sản phẩm",
    "YSPYJ": "Giá gốc sản phẩm ban đầu",
    "QSRZDJG": "Vui lòng nhập giá được chỉ định",
    "ShuLiang": "Số lượng",
    "DanWei": "Đơn vị",
    "DanJia": "Đơn giá",
    "BeiZhu": "Ghi chú",
    "YiChuShangPin": "Xóa sản phẩm",
    "XiuGai": "Chỉnh sửa",
//yunshl
    "TPSLCCYXSZ": "Số lượng ảnh vượt quá giá trị cho phép!",
    "WJBDDY5M_QC": "Tệp không được lớn hơn 5m, vui lòng chọn lại",
    "TPSCWC": "Tải ảnh hoàn tất",
//BusinessFilter
    "_DGSLM1JZ1J": "【Số lượng đặt hàng đủ {num} sản phẩm tặng {presentNum} sản phẩm】",
    "_M1JLXMJ1Y_": "【Đủ {num} sản phẩm享 ngay mỗi sản phẩm {price} đồng】",
    "_DHJJZ1Y_": "【Giá đặt hàng giảm至 {price} đồng】",
    "_M1JLXMJ1Z_": "【Đủ {num} sản phẩm享 ngay mỗi sản phẩm {discount}折】",
    "_YDHJD1Z_": "【Giá đặt hàng gốc打 {discount}折】",
    "YuJi": "Dự kiến",
    "MMYDDR": "Ngày DD tháng MM",
    "KaiShiFaHuo": "Bắt đầu giao hàng",
    "_DGSLM1Z1_": "【Số lượng đặt hàng đủ {num} tặng {presentNum}】",
    "_M1LXM1Y_": "【Đủ {num}享 ngay mỗi {price} đồng】",
    "_M1LXM1Z_": "【Đủ {num}享 ngay mỗi {discount}折】",
    "DaiQueRen": "Chờ xác nhận",
    "DaiFaHuo": "Chờ giao hàng",
    "DaiShouHuo": "Chờ nhận hàng",
    "YiWanCheng": "Đã hoàn thành",
    "DaiFuKuan": "Chờ thanh toán",
    "YiFuKuan": "Đã thanh toán",
    "YiZuoFei": "Đã hủy",
    "DaiShenHe": "Chờ kiểm duyệt",
    "DaiHeXiao": "Chờ kiểm toán",
    "YiHeXiao": "Đã kiểm toán",
    "XianXiaZhiFu": "Thanh toán trực tiếp",
    "ZhiNengDaoZhangShiBie": "Chuyển khoản trực tiếp (nhận diện đến账 tự động)",
    "WeiXinZhiFu": "Thanh toán WeChat",
    "KqZhiFu": "Thanh toán Kuaiqian (hỗ trợ WeChat/Alipay)",
    "ZFBZF": "Thanh toán Alipay",
    "YuEZhiFu": "Thanh toán số dư",
    "HuoDaoFuKuan": "Thanh toán khi nhận hàng",
    "DaiTuiHuo": "Chờ trả hàng",
    "DaiTuiKuan": "Chờ hoàn lại tiền",
    "ChuangJianDingDan": "Tạo đơn hàng",
    "BianJiDingDan": "Chỉnh sửa đơn hàng",
    "TiJiaoDingDan": "Gửi đơn hàng",
    "DingDanShenHe": "Kiểm duyệt đơn hàng",
    "CaiWuShenHe": "Kiểm duyệt tài chính",
    "BoHui": "Từ chối",
    "TianJiaShouKuan": "Thêm nhận tiền",
    "ZaiXianZhiFu": "Thanh toán trực tuyến (hỗ trợ WeChat/Alipay/Thanh toán Jingdong/Cloud Flash Pay)",
    "YinLianZhiFu": "Thanh toán Liên ngân hàng",
    "MercadoPagoZhiFu": "Thanh toán MercadoPago",
    "ShouKuanShenHe": "Kiểm duyệt nhận tiền",
    "ShouKuanZuoFei": "Hủy nhận tiền",
    "ChuKu": "Xuất kho",
    "ChuKuShenHe": "Kiểm duyệt xuất kho",
    "FaHuo": "Giao hàng",
    "TianJiaWuLiu": "Thêm logistics",
    "XiuGaiWuLiu": "Chỉnh sửa logistics",
    "ChuKuZuoFei": "Hủy xuất kho",
    "ShouHuo": "Nhận hàng",
    "DingDanHeZhun": "Xác nhận đơn hàng",
    "QuXiaoDingDan": "Hủy đơn hàng",
    "CJTHD": "Tạo đơn trả hàng",
    "DaYin": "In",
    "DaoChu": "Xuất",
    "DingDanWanCheng": "Đơn hàng hoàn thành ",
    "QiangZhiWanCheng": "Hoàn thành buộc",
    "DingDanZuoFei": "Hủy đơn hàng",
    "MaiZeng": "Mua tặng",
    "ZhiJiang": "Giảm trực tiếp",
    "DaZhe": "Giảm giá",
    "YuShou": "Đặt trước",
    "DingDanManZeng": "Đơn hàng đủ số lượng tặng",
    "DingDanManJian": "Đơn hàng đủ số lượng giảm",
    "DingDanManZhe": "Đơn hàng đủ số lượng giảm giá",
    "XinRenQuan": "Phiếu mới thành viên",
    "ManJianQuan": "Phiếu giảm khi đủ số lượng",
    "ShangPinQuan": "Phiếu sản phẩm",
    "DaiJieSuan": "Chờ thanh toán",
    "YiJieSuan": "Đã thanh toán",
    "QuanBuShangPin": "Tất cả sản phẩm",
    "TuiJianShangPin": "Sản phẩm được đề xuất",
    "XinPin": "Sản phẩm mới",
    "ReXiaoShangPin": "Sản phẩm bán chạy",
    "ChangYongShangPin": "Sản phẩm thường dùng",
//BusinessUtil
    "DaiShouKuan": "Chờ nhận tiền",
    "BuFenShouKuan": "Nhận một phần tiền",
    "YiShouKuan": "Đã nhận tiền",
    "BXYFP": "Không cần hóa đơn",
    "ZZSPTFP": "Hóa đơn VAT thông thường",
    "ZZSZYFP": "Hóa đơn VAT đặc biệt",
    "QiTaFaPiao": "Hóa đơn khác",
    "XianXia": "Trực tiếp",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "Tiền đặt cọc",
    "XianXiaZhuangZhang": "Chuyển khoản trực tiếp",
    "XianShangZhiFu": "Thanh toán trực tuyến",
    "YCKZF": "Thanh toán tiền đặt cọc",
    "DaiTiJiao": "Chờ gửi",
    "KuaiDi": "Express",
    "SongHuoShangMen": "Giao hàng tận nơi",
    "ShangMenZiQu": "Đến lấy trực tiếp",
    "WuLiuHuoYun": "Vận chuyển hàng hóa",
    "QiTa": "Khác",
//check-util
    "QSRBXY6WDM": "Vui lòng nhập mật khẩu không ít hơn 6 ký tự",
    "QSRBDY20WDM": "Vui lòng nhập mật khẩu không nhiều hơn 20 ký tự",
    "MMGSCW": "Mật khẩu định dạng sai",
//common-utils
    "SJCW_QLXKF": "Lỗi dữ liệu, vui lòng liên hệ hỗ trợ",
    "ZBZCQD": "Tạm không hỗ trợ check-in",
    "HuJiao": "Gọi",
    "DLZHBCZ": "Tài khoản đăng nhập không tồn tại",
    "QLXGLYKT": "Vui lòng liên hệ quản trị viên để mở",
    "GQYZHBJY": "Tài khoản doanh nghiệp này bị vô hiệu hóa",
    "QLXYSDH": "Vui lòng liên hệ Yunshang Order",
    "GQYZHSYQJS": "Thời gian dùng thử tài khoản doanh nghiệp này đã kết thúc",
    "GQYZHYGQL": "Tài khoản doanh nghiệp này đã hết hạn",
    "XYXFCNSY": "Cần gia hạn để có thể sử dụng",
    "GQYBCZCZH": "Doanh nghiệp này không có tài khoản này",
    "NDDHZHYBQY": "Tài khoản đặt hàng của bạn đã bị doanh nghiệp 1 vô hiệu hóa, không thể đăng nhập. Vui lòng liên hệ quản trị viên",
    "NYBSQY1DHZ": "Bạn không còn là khách hàng hợp tác của doanh nghiệp 1, không thể đăng nhập. Vui lòng liên hệ quản trị viên",
    "NDDPYBTY_B": "Cửa hàng của bạn đã bị tạm dừng, không thể đăng nhập. Vui lòng liên hệ quản trị viên",
    "GZHWKTDSZB": "Tài khoản này chưa mở chức năng phiên bản đèn trang trí. Vui lòng liên hệ quản trị viên",
    "WXSQYZYGQ": "Xác thực ủy quyền WeChat đã hết hạn",
    "WXSQSB": "Xác thực ủy quyền WeChat thất bại",
    "WXSQSB_CWX": "Xác thực ủy quyền WeChat thất bại, thông tin lỗi",
    "DengLuGuoQi": "Đăng nhập hết hạn",
    "DLGQ_QCXDL": "Đăng nhập hết hạn, vui lòng đăng nhập lại",
//data-constant
    "ShangJia": "Đăng bán",
    "YiXiaJia": "Đã下架",
    "YiJinYong": "Đã vô hiệu hóa",
    "YiQiYong": "Đã kích hoạt",
    "YiTingYong": "Đã tạm dừng",
    "KeHuZhuCe": "Khách hàng đăng ký",
    "XinZengDaoRu": "Thêm nhập",
    "DDDSH": "Chờ kiểm duyệt đơn hàng",
    "DCWSH": "Chờ kiểm duyệt tài chính",
    "DaiChuKu": "Chờ xuất kho",
    "DCK_BF_": "Chờ xuất kho (một phần)",
    "DFH_BF_": "Chờ giao hàng (một phần)",
    "DSH_BF_": "Chờ nhận hàng (một phần)",
    "DSK_BF_": "Chờ nhận tiền (một phần)",
    "WTHSQ": "Không có yêu cầu trả hàng",
    "THDSH": "Trả hàng chờ kiểm duyệt",
    "THCLZ": "Đang xử lý trả hàng",
    "THYWC": "Trả hàng đã hoàn thành",
    "DYDHD": "In đơn đặt hàng",
    "DYFHD": "In đơn giao hàng",
    "DCDHD": "Xuất đơn đặt hàng",
    "DCFHDWE_P": "Xuất đơn giao hàng thành tệp Excel/PDF",
    "TuiDanZuoFei": "Hủy đơn trả hàng",
    "DTHSH": "Chờ kiểm duyệt trả hàng",
    "DaiRuKu": "Chờ nhập kho",
    "DRK_BF_": "Chờ nhập kho (một phần)",
    "DFK_BF_": "Chờ thanh toán (một phần)",
    "ChuangJianTuiDan": "Tạo đơn trả hàng",
    "BianJiTuiDan": "Chỉnh sửa đơn trả hàng",
    "TiJiaoTuiDan": "Gửi đơn trả hàng",
    "TuiHuoShenHe": "Kiểm duyệt trả hàng",
    "RuKu": "Nhập kho",
    "RuKuShenHe": "Kiểm duyệt nhập kho",
    "RuKuZuoFei": "Hủy nhập kho",
    "TianJiaFuKuan": "Thêm thanh toán",
    "FuKuanZuoFei": "Hủy thanh toán",
    "FuKuanShenHe": "Kiểm duyệt thanh toán",
    "TuiDanWanCheng": "Đơn trả hàng hoàn thành",
    "QiTaChuKu": "Xuất kho khác",
    "XiaoShouChuKu": "Xuất kho bán hàng",
    "PanKuiChuKu": "Xuất kho thiệt hại",
    "DiaoBoChuKu": "Xuất kho chuyển调拨",
    "CaiGouTuiHuo": "Trả hàng mua sắm",
    "TuiHuoRuKu": "Nhập kho trả hàng",
    "CaiGouRuKu": "Nhập kho mua sắm",
    "QiTaRuKu": "Nhập kho khác",
    "PanYingRuKu": "Nhập kho lãi",
    "DiaoBoRuKu": "Nhập kho chuyển调拨",
    "CJCGD": "Tạo đơn mua sắm",
    "BJCGD": "Chỉnh sửa đơn mua sắm",
    "TJCGD": "Gửi đơn mua sắm",
    "CGDZF": "Hủy đơn mua sắm",
    "CGDWC": "Đơn mua sắm hoàn thành",
    "CGTHZF": "Hủy trả hàng mua sắm",
    "CGTHWC": "Trả hàng mua sắm hoàn thành",
    "THDDY": "In đơn trả hàng",
    "THDDC": "Xuất đơn trả hàng",
    "CKDDY": "In đơn xuất kho",
    "CKDDC": "Xuất đơn xuất kho",
    "GLDZH": "Tài khoản quản lý",
    "DHDZH": "Tài khoản đặt hàng",
    "ShenHeTongGuo": "Kiểm duyệt thông qua",
    "SHBTG": "Kiểm duyệt không thông qua",
    "WuXuFaPiao": "Không cần hóa đơn",
    "DaiKeXiaDan": "Đặt hàng thay khách",
    "ZiZhuXiaDan": "Đặt hàng tự chủ",
    "PCShangCheng": "Cửa hàng PC",
    "APPShangCheng": "Cửa hàng APP",
    "TVShangCheng": "Cửa hàng TV",
    "WeiXinShangCheng": "Cửa hàng WeChat",
    "ShouJiShangCheng": "Cửa hàng di động",
    "ADDXSMLTC": "Tiền hoa hồng theo lợi nhuận bán hàng của đơn hàng",
    "ADDXSSRTC": "Tiền hoa hồng theo doanh thu bán hàng của đơn hàng",
    "AKHSSYG": "Theo nhân viên thuộc khách hàng",
    "AnZhiDanRen": "Theo người lập đơn",
    "ATHJEBLKCT": "Khoản hoa hồng được trừ theo tỷ lệ số tiền trả hàng",
    "DDYTHBJXTC": "Đơn hàng có trả hàng không được tính hoa hồng",
    "DaiDaKuan": "Chờ chuyển khoản",
    "WeiKaiShi": "Chưa bắt đầu",
    "JinXingZhong": "Đang diễn ra",
    "YiGuoQi": "Đã hết hạn",
//Utils.js
    "YouHuo": "Có hàng",
    "WuHuo": "Hết hàng",
    "Yi": "tỷ",
    "QianWan": "trăm triệu",
    "BaiWan": "triệu",
    "Wan": "vạn",
    "Sheng1Tian": "Còn 1 ngày",
    "Sheng1XiaoShi": "Còn 1 giờ",
    "Miao": "giây",
    "1Miao": "1 giây",
    "GangGang": "Vừa xong",
    "1FenZhongQian": "1 phút trước",
    "1XiaoShiQian": "1 giờ trước",
    "1TianQian": "1 ngày trước",
    "1GeYueQian": "1 tháng trước",
    "1NianQian": "1 năm trước",
    "WeiZhiLeiXing": "Loại không xác định",
//WechatUtil
    "YYGBCDSP_K": "Có một sản phẩm tốt, hãy đến xem",
    "ZanWeiSheZhi": "Tạm chưa thiết lập",
//app
    "HQWXSQXX": "Lấy thông tin ủy quyền WeChat",
//flexible
    "JGJYYDMBQ": "Sẽ thiết lập tỷ lệ phóng to dựa trên thẻ meta hiện có",
//index
    "NLJZZ": "Đang tải",
//routes
    "ShangPinMingXi": "Chi tiết sản phẩm",
    "ShangPinLeiBie": "Loại sản phẩm",
    "QXZFPNR": "Vui lòng chọn nội dung hóa đơn",
    "QXZFPLX": "Vui lòng chọn loại hóa đơn",
    "QTXFPTT": "Vui lòng điền抬头 hóa đơn",
    "FaPiaoTaiTou": "抬头 hóa đơn",
    "NSRSBH": "Mã nhận diện thuế",
    "FaPiaoNeiRong": "Nội dung hóa đơn",
    "FaPiaoXinXi": "Thông tin hóa đơn",
    "KaiJuFaPiao": "Xuất hóa đơn",
    "FaPiaoLeiXing": "Loại hóa đơn",
    "Han": "Bao gồm",
    "WeiHan": "Không bao gồm",
    "Shui": "Thuế",
    "QSRFPTT": "Vui lòng nhập抬头 hóa đơn",
    "QSRNSRSBH": "Vui lòng nhập mã nhận diện thuế",
//routes
//cart-bill
    "YiManZu_Man": "Đã đáp ứng【đủ",
    "ZaiGou": "Mua thêm",
    "YMZ_DHJJZ": "Đã đáp ứng【giá đặt hàng giảm至",
    "JianJiangZhi": "sản phẩm giảm至",
    "YMZ_YDHJD": "Đã đáp ứng【giá đặt hàng gốc打",
    "JianMeiJian": "sản phẩm mỗi sản phẩm",
    "SYTCSLW0_WFJRGWC": "Số lượng gói còn lại là 0, không thể thêm vào giỏ hàng",
    "QingXuanXeShangPin": "Vui lòng chọn sản phẩm!",
    "GSPYXJ": "Sản phẩm này đã下架!",
    "ZJ2TN": "Trong 2 ngày gần đây",
    "QDQCXJSP": "Chắc chắn muốn xóa sản phẩm下架?",
    "QingChuChengGong": "Xóa thành công",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "Sản phẩm gói không được thêm vào giỏ hàng, vui lòng hủy sản phẩm gói trước khi di chuyển vào giỏ hàng!",
    "SPSLBN": "Số lượng sản phẩm không thể",
    "TaoCanHan": "Gói bao gồm",
    "TaoCan": "Gói",
    "QHDSL": "Vui lòng kiểm tra số lượng",
    "SPSLBNDY": "Số lượng sản phẩm không thể thấp hơn",
    "XianDingLiang": "Lượng giới hạn đặt",
    "YiRuShouCang": "Di chuyển vào bộ sưu tập",
    "QuanXuan": "Chọn tất cả",
    "JianZeng": "sản phẩm tặng",
    "JianLiXiang_Man": "sản phẩm享【đủ",
    "Yuan_": "đồng】",
    "Zhe_": "chiếc】",
    "KCBZ_WFJRGWC": "Kho không đủ, không thể thêm vào giỏ hàng",
    "XDJEDYDY": "Số tiền đặt hàng lớn hơn hoặc bằng",
    "WYXJHYSXDSP": "Không có sản phẩm đã下架 hoặc đã hết hiệu lực!",
    "DYQDL": "Thấp hơn lượng đặt tối thiểu",
    "ZSPG1J": "{count} loại sản phẩm, tổng cộng {number} sản phẩm",
    "WanCheng": "Hoàn thành",
    "BianJi": "Chỉnh sửa",
    "You": "Có",
    "ZSPBFHYQ_W": "loại sản phẩm không đáp ứng yêu cầu, chưa được chọn, click để kiểm tra địa chỉ mặc định",
    "SPSLBNGY": "Số lượng sản phẩm không thể cao hơn",
    "JXDJ_CKXYGBFHYQSP": "Tiếp tục click, xem sản phẩm không đáp ứng yêu cầu tiếp theo",
    "XiaDan": "Đặt hàng",
    "JianJiang": "sản phẩm giảm",
    "QRYCSP": "Chắc chắn muốn xóa sản phẩm?",
    "QXZXDSP": "Vui lòng chọn sản phẩm đặt hàng",
    "KCBZ_QCXXZ": "Kho không đủ, vui lòng chọn lại!",
    "KuCun": "Kho",
    "YCKXD": "đồng mới có thể đặt hàng",
    "QDSCSP": "Chắc chắn muốn lưu sản phẩm?",
    "ShouCangChengGong": "Lưu thành công",
    "GYXDL": "Cao hơn lượng giới hạn đặt",
    "LiSheng": "Tiết kiệm ngay",
    "GWCHSKD_QGYGB": "Giỏ hàng vẫn trống, đi逛逛 nhé",
    "QuGuangGuang": "Đi逛逛",
    "QCXJSP": "Xóa sản phẩm下架",
    "ZongE": "Tổng số",
    "YouHui": "Ưu đãi",
//cart-list
    "QXZJHRQ": "Vui lòng chọn ngày giao hàng",
    "FuJiaFeiYong": "Phí bổ sung",
    "ZhongShangPin_Gong": "loại sản phẩm, tổng cộng",
    "PeiSongShiJian": "Thời gian giao hàng",
    "QXZPSSJ": "Vui lòng chọn thời gian giao hàng",
    "DingDanJinE": "Số tiền đơn hàng",
    "SCFJ_ZD4Z": "Tải lên tệp đính kèm, tối đa {num} tấm, mỗi tấm không vượt quá {size}",
    "KeYongShangPin": "Sản phẩm có thể sử dụng",
    "ShiYongShuoMing": "Hướng dẫn sử dụng",
    "YouXiaoQi": "Thời hạn hiệu lực",
    "Man": "Đủ",
    "BZZBZCTSFH": "Ghi chú tạm không hỗ trợ ký tự đặc biệt",
    "QingXuanZe": "Vui lòng chọn",
    "KaiPiaoXuJia": "Xuất hóa đơn cần cộng",
    "PeiSongFangShi": "Phương thức giao hàng",
    "ShangPinZongJia": "Tổng giá sản phẩm",
    "YouHuiQuan": "Phiếu ưu đãi",
    "ZhangKeXan": "chỉ có thể chọn",
    "DDJEWMZ": "Số tiền đơn hàng chưa đáp ứng",
    "WDYHQ": "Phiếu ưu đãi của tôi",
    "KYYHQ": "Phiếu ưu đãi có thể sử dụng",
    "YuanKeYong": "đồng có thể sử dụng",
    "ChaKanDingDan": "Xem đơn hàng",
    "ShangPinHanShui": "Sản phẩm bao gồm thuế",
    "SPWHS": "Sản phẩm không bao gồm thuế",
    "GeDian": "điểm",
    "QueRenDingDan": "Xác nhận đơn hàng",
    "XZSHDZ": "Thêm địa chỉ nhận hàng",
    "ShangPinQingDan": "Danh sách sản phẩm",
    "WKYYHQ": "Không có phiếu ưu đãi có thể sử dụng",
    "HuChi": "Đầu tấu",
    "DaiJinQuan": "Phiếu giảm giá",
    "YunFei": "Phí vận chuyển",
    "ShuiFei": "Phí thuế",
    "WKYYY": "Lý do không thể sử dụng",
    "YHQYGQ": "Phiếu ưu đãi đã hết hạn",
    "WDYHQSYSJ": "Chưa đến thời gian sử dụng phiếu ưu đãi",
    "ZDSPJEWMZ": "Số tiền sản phẩm được chỉ định chưa đáp ứng",
    "BKYYHQ": "Phiếu ưu đãi không thể sử dụng",
    "RMBJE":"Số tiền Nhân dân tệ",
//cart-presale-order
    "QXZPSFS": "Vui lòng chọn phương thức giao hàng",
    "1ZSP_G": "1 loại sản phẩm, tổng cộng",
    "YSSP_YJ": "Sản phẩm đặt trước, dự kiến",
    "JiaoHuoRiQi": "Ngày giao hàng",
    "GMJLY": "Lời nhắn cho người bán",
//scan-to-cart
    "ZhengZaiChuLi...": "Đang xử lý...",
    "FSCSP": "Sản phẩm không phải của商城",
    "ZZCLTXM": "Đang xử lý mã vạch...",
    "SPTJCG": "Thêm sản phẩm thành công",
    "QSTXM": "Vui lòng quét mã vạch",
    "SFSCDQSP": "Có chắc chắn muốn xóa sản phẩm hiện tại?",
    "BQ_ZBDXGSP": "Xin lỗi, không tìm thấy sản phẩm liên quan",
    "XuanZeDanWei": "Chọn đơn vị",
    "JRGWC": "Thêm vào giỏ hàng",
    "QXXZDJRSP": "Vui lòng chọn sản phẩm cần thêm trước",
    "ZhengZaiChuLi": "Đang xử lý",
    "JRGWCCG": "Thêm vào giỏ hàng thành công",
    "ZanWuShangPin": "Không có sản phẩm",
//earn-brokerage-share
    "XTYJBNFZSP": "Hệ thống đã帮您复制链接 sản phẩm！",
    "NKYHDDYDYJ": "Bạn có thể nhận được hoa hồng tương ứng. Hoa hồng có thể xem trong \"Tôi的",
    "LiChaKan": "trong xem",
    "WeiXinHaoYou": "Bạn bè WeChat",
    "ErWeiMa": "Mã QR",
    "CASBEWM": "Nhấn dài để nhận dạng mã QR",
    "FZSB_QCXFZ": "Sao chép thất bại, vui lòng sao chép lại！",
    "TWEWM": "Mã QR hình ảnh văn bản",
    "BCDXC": "Lưu vào álbum",
    "CATPBCDXC": "Nhấn dài hình ảnh để lưu vào álbum",
    "FuZhiLianJie": "Sao chép liên kết",
    "FXZYJ": "Chia sẻ để kiếm hoa hồng",
    "YJZGKZQYJ": "Dự kiến tối đa có thể kiếm hoa hồng",
//goods-share
    "FXSPGLSKH": "Chia sẻ sản phẩm cho khách hàng bán lẻ",
    "FXHJSCNZSD": "Sau khi chia sẻ, sẽ tạo ra cửa hàng micro của bạn专属, bạn có thể thiết lập giá của sản phẩm trong cửa hàng, điền thông tin liên hệ của bạn, thu hút người tiêu dùng đến mua.",
    "WSCDQJG_ND": "Giá hiện tại của cửa hàng micro: Giá đặt hàng của bạn ×",
    "DaiSheZhi": "Chờ thiết lập",
    "PengYouQuan": "Danh sách bạn bè",
    "GGFXSZ": "Thay đổi cài đặt chia sẻ",
//wechat-login
    "QXSRZH": "Vui lòng nhập tài khoản trước",
    "MMGSCW_6_20W": "Mật khẩu định dạng sai (6-20 ký tự chữ hoặc số)",
    "BDYYZH": "Liên kết tài khoản hiện có",
    "WXKJDL": "Đăng nhập nhanh WeChat",
    "BangDingZhangHao": "Liên kết tài khoản",
    "YYZH_QDL": "Đã có tài khoản, đến đăng nhập",
    "ZCXZH": "Đăng ký tài khoản mới",
    "HuanYingNi": "Chào mừng bạn",
    "ZH_SJHM": "Tài khoản/Số điện thoại",
    "MiMa": "Mật khẩu",
    "QDLHCZ": "Vui lòng đăng nhập trước khi thao tác",
//add-to-cart
    "KCBZ_BNTJG": "Kho không đủ, không thể thêm nhiều hơn",
//combined-pay-online
    "ZhiFuChengGong": "Thanh toán thành công！",
    "ZFSB_QCXCS": "Thanh toán thất bại, vui lòng thử lại！",
//
    "QXXZGG": "Vui lòng chọn quy cách trước",
    "SXGGX": "Quy cách đã chọn cần",
    "GMSLXYQDL_": "Số lượng mua ít hơn lượng đặt tối thiểu, vui lòng mua lại！",
    "GMSLDYXDL_": "Số lượng mua nhiều hơn lượng giới hạn đặt, vui lòng mua lại！",
    "ShangPinBianHao": "Mã sản phẩm",
    "QiDing": "Đặt tối thiểu",
    "SXGGDGSLBK": "Số lượng đặt của quy cách đã chọn không được vượt quá",
    "KCBZ_BNTJ": "Kho không đủ, không thể thêm",
    "QXXZSP": "Vui lòng chọn sản phẩm trước",
    "SLBNW0": "Số lượng không thể là 0",
    "QXZGG": "Vui lòng chọn quy cách",
    "LiJiYuDing": "Đặt ngay",
//nav
    "ShouYe": "Trang chủ",
    "ShangPin": "Sản phẩm",
    "DingDan": "Đơn hàng",
    "WoDe": "Của tôi",
//pay-online
    "ZhiFuQuXiao": "Hủy thanh toán",
//account-log
    "ShangPinYongJin": "Hoa hồng sản phẩm",
    "YaoQingJiangLi": "Phần thưởng mời",
    "TiXian": "Rút tiền",
    "TiXianBoHui": "Rút tiền bị từ chối",
    "ZhuanWeiYuE": "Chuyển thành số dư",
    "Jin7Tian": "7 ngày gần đây",
    "Jin30Tian": "30 ngày gần đây",
    "ShouZhiMingXi": "Chi tiết thu chi",
    "ZanWuShuJu": "Không có dữ liệu",
//client-statistics
    "WoDeKeHu": "Khách hàng của tôi",
    "WoDeYaoQing": "Lời mời của tôi",
//distribution-home
    "LeiJiKeHu": "Tổng khách hàng",
    "LeiJiDingDan": "Tổng đơn hàng",
    "YaoQingHaoYou": "Mời bạn bè",
    "LeiJiYaoQing": "Tổng lời mời",
    "LJSY_Y_": "Tổng thu nhập (đồng)",
    "BHDJS": "Bao gồm chờ thanh toán",
    "J7TSY_Y_": "Thu nhập 7 ngày gần đây (đồng)",
    "J7TXZKH_R_": "Khách hàng mới 7 ngày gần đây (người)",
    "KTXYJ": "Hoa hồng có thể rút",
    "XYJYO": "Cần cố gắng nhé",
    "ChangJianWenTi": "Câu hỏi thường gặp",
    "Q_ZMYJX_TG": "Q：Làm thế nào để \"kinh doanh quảng cáo để kiếm tiền",
    "A_FXDPND_Z_": "A：Chia sẻ liên kết trang có biểu tượng \"kiếm\" trong cửa hàng, thu hút bạn bè click, bạn bè đăng ký (mối quan hệ khách hàng được thiết lập là liên kết ngay khi đăng ký) hoặc đặt hàng (mối quan hệ khách hàng được thiết lập là liên kết khi đặt hàng) mua sản phẩm có biểu tượng \"kiếm\" trong cửa hàng, sẽ được tính là thu nhập \"kinh doanh quảng cáo để kiếm tiền\" theo phương pháp tính toán nhất định.",
    "Q_RHJS_TGZ": "Q：Làm thế nào để tính thu nhập \"kinh doanh quảng cáo để kiếm tiền\"？",
    "A_MGD_Z_TBD": "A：Mỗi sản phẩm có biểu tượng \"kiếm\" đều có tỷ lệ hoa hồng nhất định, những sản phẩm không có dấu hiệu này có nghĩa là không tham gia \"kinh doanh quảng cáo để kiếm tiền\". Sau khi bạn bè thanh toán thành công qua liên kết chia sẻ của bạn, sẽ tính hoa hồng theo tỷ lệ hoa hồng của từng sản phẩm trong đơn hàng (hoa hồng không tham gia quảng cáo là 0), cuối cùng cộng lại thành thu nhập hoa hồng của đơn hàng này. Thu nhập tính toán sẽ trừ đi phí vận chuyển, hoàn tiền, giảm giá khi đủ số lượng, v.v., dựa trên giá thành cuối cùng.",
    "Q_TGZQ_DSY": "Q：Khi nào thu nhập của \"kinh doanh quảng cáo để kiếm tiền\" đến账？",
    "A_HYTGNDFX": "A：Sau khi bạn bè thanh toán thành công qua liên kết chia sẻ của bạn, bạn có thể xem quảng cáo này trong đơn hàng quảng cáo của trung tâm bán hàng, trạng thái là chờ thanh toán, sau khi khách hàng xác nhận nhận hàng, giao dịch đơn hàng hoàn thành thanh toán, thu nhập này sẽ tự động chuyển vào tài khoản cá nhân của bạn, có thể rút tiền bất cứ lúc nào.",
    "Q_LJKH_LJY": "Q：Danh sách khách hàng tích lũy, lời mời tích lũy không có ảnh đại diện tên gọi？",
    "A_WXYQZYGZ": "A：WeChat yêu cầu chỉ có khi theo dõi dịch vụ xác thực mới có thể lấy ảnh đại diện tên gọi, khách hàng của cửa hàng là dịch vụ xác thực theo dõi tài khoản công khai cửa hàng, không phải dịch vụ xác thực theo dõi \"Yunshang Order\" tài khoản công khai sau đó click bất kỳ trang chi tiết sản phẩm cửa hàng nào có thể lấy ảnh đại diện tên gọi.",
    "Q_WSMWASSG": "Q：Tại sao tôi chia sẻ theo quy tắc trên, không nhận được thu nhập quảng cáo？",
    "A_1_HYKNBW": "A：1、Bạn bè có thể chưa thiết lập mối quan hệ khách hàng với bạn (bạn bè click liên kết của nhân viên phân phối khác để đăng ký hoặc đặt hàng) 2、Nếu bạn bè mở liên kết chia sẻ của bạn ngoài môi trường WeChat (như trình duyệt mặc định của điện thoại), nếu trình duyệt không开启 cookie, cũng sẽ không thể ghi lại mối quan hệ khách hàng, tức là không thể ghi lại đơn hàng quảng cáo 3、Tất cả các vấn đề trên đều không có vấn đề nhưng vẫn không ghi lại đơn hàng quảng cáo, vui lòng liên hệ nhân viên làm việc",
//
    "XiaoShouZhongXin": "Trung tâm bán hàng",
//generalize-goods
    "SPMC_GG_BH": "Tên sản phẩm / Quy cách / Mã số",
    "YuJiZhuan": "Dự kiến kiếm",
//invitation-home
    "YaoQingKa": "Thẻ mời",
    "YNYQJR_TGY": "Mời bạn tham gia cùng nhau, quảng cáo để giành phần thưởng",
    "DJBCDXC": "Click để lưu vào álbum",
    "JYQKFSGHY_": "Gửi thẻ mời cho bạn bè, quảng cáo cửa hàng có phần thưởng",
//join-home
    "HuanYingJiaRu": "Chào mừng tham gia",
    "YQNCW": "Mời bạn trở thành",
    "LiJiJiaRu": "Tham gia ngay",
//order-statistics
    "YuJiYongJin": "Dự kiến hoa hồng",
    "YongJin": "Hoa hồng",
    "YuJiJiangLi": "Dự kiến phần thưởng",
    "JiangLi": "Phần thưởng",
    "SPTGDD": "Đơn hàng quảng cáo sản phẩm",
    "YQJLDD": "Đơn hàng phần thưởng mời",
//performance-statistics
    "YeJiTongJi": "Thống kê业績",
    "LJKH_R_": "Tổng khách hàng（người）",
    "SPYJ_Y_": "Hoa hồng sản phẩm（đồng）",
    "HanDaiJieSuan": "Bao gồm chờ thanh toán",
    "XGMCJS": "Giải thích thuật ngữ liên quan",
    "KeHu": "Khách hàng",
    "HFXYBDLKHG": "Người mua hoặc nhân viên phân phối có mối quan hệ khách hàng với nhân viên phân phối",
    "YaoQing": "Mời",
    "FXYCGYQDXJ": "Nhân viên phân phối cấp dưới được mời thành công bởi nhân viên phân phối",
    "FXYTJKHGMH": "Hoa hồng mà nhân viên phân phối có thể nhận được sau khi giới thiệu khách hàng mua",
    "XJFXYTGSPH": "Phần thưởng mà cấp trên nhận được sau khi nhân viên phân phối cấp dưới quảng cáo sản phẩm",
//posters-promoting
    "NiCheng": "Biệt danh",
    "HaiBaoTuiGuang": "Quảng cáo áp phích",
    "JHBFSGHY_T": "Gửi áp phích cho bạn bè, quảng cáo cửa hàng có phần thưởng",
//settlement-home
    "JieSuanZhongXin": "Trung tâm thanh toán",
    "KTXJE": "Số tiền có thể rút",
    "TiXianJiLu": "Lịch sử rút tiền",
//withdraw-account
    "KHRXMBNWK": "Tên chủ tài khoản không được để trống！",
    "KHHBNWK": "Ngân hàng mở tài khoản không được để trống！",
    "YHKHBNWK": "Số tài khoản ngân hàng không được để trống！",
    "SFZTPBNWK": "Hình ảnh CCCD không được để trống！",
    "YHKTPBNWK": "Hình ảnh thẻ ngân hàng không được để trống！",
    "BaoCunChengGong": "Lưu thành công！",
    "SCSFZ": "Tải lên CCCD",
    "SCYHK": "Tải lên thẻ ngân hàng",
    "BaoCun": "Lưu",
    "TiXianZhangHu": "Tài khoản rút tiền",
    "TS_QTXZSXX": "Lưu ý：Vui lòng điền thông tin thực tế, có thể rút tiền sau khi kiểm duyệt qua",
    "KHRXM": "Tên chủ tài khoản",
    "KaiHuHang": "Ngân hàng mở tài khoản",
    "YinhangKaHao": "Số thẻ ngân hàng",
    "QSRZSXM": "Vui lòng nhập tên thực tế",
    "QSRKHHMC": "Vui lòng nhập tên ngân hàng mở tài khoản",
    "QSRYHKH": "Vui lòng nhập số thẻ ngân hàng",
//withdraw-deposit
    "QXSZTXZH": "Vui lòng thiết lập tài khoản rút tiền trước",
    "QuSheZhi": "Đi thiết lập",
    "JEXY10Y_BKT": "Số tiền ít hơn 10 đồng, không thể rút！",
    "JECGKTXJE": "Số tiền vượt quá số tiền có thể rút！",
    "CGDRKTXSX_": "Vượt quá giới hạn rút tiền ngày, giới hạn rút tiền ngày là 20000 đồng！",
    "QueDingJiang": "Chắc chắn sẽ",
    "ZhuanDaoYuE": "chuyển đến số dư?",
    "1_JEDY10YSB": "1、Số tiền thấp hơn 10 đồng không thể rút；",
    "2_BCTXDZSJ": "2、Thời gian đến账 của lần rút tiền này là trong 5 ngày làm việc kể từ khi gửi yêu cầu rút tiền thành công, giới hạn rút tiền ngày là 20000 đồng；",
    "3_GBSRWHSS": "3、Số thu nhập này là số thu nhập có thuế, vui lòng tự đến cơ quan thuế liên quan để申报 và nộp thuế thu nhập cá nhân！",
    "4_ZDYEKYYS": "4、Chuyển đến số dư có thể sử dụng để mua sắm trong商城；",
    "TXSQCG_QDD": "Yêu cầu rút tiền thành công, vui lòng đợi kiểm duyệt",
    "JEDYKTXJE_": "Số tiền lớn hơn số tiền có thể rút, không thể chuyển đến số dư！",
    "ZZYECG_QDG": "Chuyển số dư thành công, đến trung tâm cá nhân để xem！",
    "BenCiTiXian": "Lần rút tiền này",
    "ZhuangDaoYuE": "Chuyển đến số dư",
    "TiXianDao": "Rút tiền đến",
    "JEW0BKZZYE": "Số tiền là 0 không thể chuyển đến số dư！",
    "DRTXSX2WY": "Giới hạn rút tiền ngày 20.000 đồng",
    "QuanBuTiXian": "Rút tất cả",
    "QueRenTiXian": "Xác nhận rút tiền",
//goods-filter-tab
    "ZuiChangGouMai": "Mua thường xuyên nhất",
    "MoRenPaiXu": "Sắp xếp mặc định",
    "ZongHe": "Tổng hợp",
    "FenLei": "Phân loại",
    "XiaoLiangYouXian": "Ưu tiên theo số lượng bán",
    "XiaoLiang": "Số lượng bán",
    "JiaGe": "Giá",
    "ShaiXuan": "Lọc",
    "ZuiJinGouMai": "Mua gần đây nhất",
    "CuXiaoYouXian": "Ưu tiên khuyến mãi",
    "QuanBuFenLei": "Tất cả phân loại",
    "ZhiKanCuXiao": "Chỉ xem khuyến mãi",
    "XuanZeFenLei": "Chọn phân loại",
    "QXZFL": "Vui lòng chọn phân loại",
//goods-list-default
    "ZWXGSP": "Không có sản phẩm liên quan",
//goods-brand-list
    "PinPaiHui": "Hội thương hiệu",
//goods-classify-filter
    "TuiJianFenLei": "Phân loại đề xuất",
    "ShangPinFenLei": "Phân loại sản phẩm",
    "GengDuo": "Thêm",
//goods-detail
    "DLZHBSDQQY": "Tài khoản đăng nhập không phải là tài khoản khách hàng doanh nghiệp hiện tại",
    "GXNHQ": "Chúc mừng bạn nhận được",
    "SZWSCJGH_C": "Sau khi thiết lập giá cửa hàng micro, mới có thể chia sẻ",
    "JHDJSHS_": "Còn lại cho đến khi kết thúc hoạt động",
    "DLHKFX": "Đăng nhập để có thể chia sẻ",
    "ZZHQXX_QSH": "Đang lấy thông tin, vui lòng thử lại sau",
    "Zhang": "tấm",
    "Tian": "ngày",
    "QXZGGZQPD": "Vui lòng chọn quy cách trước khi cài đèn！",
    "Yuan": "đồng",
    "XS_F_M": "giờ/phút/giây",
//integral
    "WoDeJiFen": "Điểm của tôi",
    "DaBaiLe": "Đã đánh bại",
    "JiFen": "Điểm",
    "DeHuiYuan": "của hội viên",
    "ZhuanJiFen": "Kiếm điểm",
    "JiFenMingXi": "Chi tiết điểm",
    "HuanLiPin": "Đổi quà",
    "CKGDHL": "Xem thêm quà tốt",
    "ChaDingDan": "Kiểm tra đơn hàng",
//integral-convert
    "DHSLBNCG": "Số lượng đổi không được vượt quá",
    "DuiHuanShuLiang": "Số lượng đổi",
    "SuoXuJiFen": "Điểm cần thiết",
//integral-detail
    "LiPinXiangQing": "Chi tiết quà tặng",
    "WoYaoDuiHuan": "Tôi muốn đổi",
    "ShengYu": "Còn lại",
    "TuWenXiangQing": "Chi tiết hình văn",
    "YiDuiWan": "Đã đổi xong",
//integral-filter
    "FenLeiShaiXuan": "Lọc phân loại",
    "JiFenShaiXuan": "Lọc điểm",
//integral-flow
    "JiFenShouRu": "Thu nhập điểm",
    "JiFenZhiChu": "Chi tiêu điểm",
//integral-logistics
    "DingDanGenZong": "Theo dõi đơn hàng",
    "WuLiuGongSi": "Công ty logistics",
    "WuLiuDanHao": "Số đơn logistics",
//integral-order
    "DingDanLieBiao": "Danh sách đơn hàng",
    "YiFaHuo": "Đã giao hàng",
    "JiFenDingDan": "Đơn hàng điểm",
    "ChaKanWuLiu": "Xem logistics",
//integral-order-create
    "LPSLBZ_QCX": "Số lượng quà tặng không đủ, vui lòng thanh toán lại",
    "JiFenBuZu": "Điểm không đủ",
    "ZhiFuXinXi": "Thông tin thanh toán",
    "JiXuGuangGuang": "Tiếp tục逛逛",
    "QTXSHXX": "Vui lòng điền thông tin nhận hàng",
    "DuiHuanChengGong": "Đổi thành công",
    "LPDHQR": "Xác nhận đổi quà tặng",
    "SCCKJ": "Giá tham khảo thị trường",
    "LiJiZhiFu": "Thanh toán ngay",
//integral-order-detail
    "DingDanXiangQing": "Chi tiết đơn hàng",
    "DingDanZhuangTai": "Trạng thái đơn hàng",
    "DingDanBianHao": "Mã đơn hàng",
    "DuiHuanShiJian": "Thời gian đổi",
    "ShouHuoXinXi": "Thông tin nhận hàng",
    "HuaFeiJiFen": "Điểm tiêu tốn",
//integral-rule
    "QDZJF": "Check-in để kiếm điểm",
    "XDZJF": "Đặt hàng để kiếm điểm",
    "DDWCHKHDYD": "Sau khi đơn hàng hoàn thành, có thể nhận được với số tiền đơn hàng*",
    "1_MRQD_JL": "1、Check-in hàng ngày, thưởng",
    "2_LXQD3T_EW": "2、Check-in liên tục 3 ngày, thưởng thêm",
    "3_LXQD7T_EW": "3、Check-in liên tục 7 ngày, thưởng thêm",
    "BeiDeJiFen": "lần điểm",
    "DLZJF": "Đăng nhập để kiếm điểm",
    "MeiRiDengLu": "Đăng nhập hàng ngày",
    "SC_JL": "商城, thưởng",
//integral-rule-detail
    "GuiZe": "Quy tắc",
//integral-sign
    "QianDaoYouLi": "Check-in có quà",
    "QianDaoGuiZe": "Quy tắc check-in",
    "YLXQD": "Đã check-in liên tục",
    "QDCG_NYJLX": "Check-in thành công, bạn đã check-in liên tục",
    "QDCG_BCHD": "Check-in thành công, lần này nhận được",
    "QSRBZ": "Vui lòng nhập ghi chú",
    "DingDanZengPin": "Sản phẩm tặng đơn hàng",
    "GuiGeBianHao": "Mã quy cách",
    "GuiGe": "Quy cách",
//combined-pay
    "CDDWXFK": "Đơn hàng này không cần thanh toán",
    "YHYEBZ": "Số dư người dùng không đủ！",
    "ZFJEBNW0": "Số tiền thanh toán không thể là 0！",
    "ZFJEBNDYDD": "Số tiền thanh toán không thể lớn hơn số tiền chờ thanh toán của đơn hàng",
    "DFKJE": "Số tiền chờ thanh toán",
    "FuKuanFangShi": "Phương thức thanh toán",
    "FuJian": "Đính kèm",
    "ZHYFZ": "Tài khoản đã được sao chép",
    "GHSKZH": "Thay đổi tài khoản nhận tiền",
    "SYXXZFQSCF": "Sử dụng thanh toán trực tiếp vui lòng tải lên ảnh chụp màn hình thanh toán, để tài chính xác nhận số tiền！",
    "XXZF_BXXZS": "Thanh toán trực tiếp, phải chọn tài khoản nhận tiền",
    "DingDanZhiFu": "Thanh toán đơn hàng",
    "ZFFS_HDFK": "Phương thức thanh toán：Thanh toán khi nhận hàng",
    "BCFKJE": "Số tiền thanh toán lần này",
    "YuE": "Số dư",
    "FuZhiZhangHao": "Sao chép tài khoản",
    "WSZXCXZFPZ": "Chưa thiết lập cấu hình thanh toán小程序",
    "XCXZFZHJY": "Tài khoản thanh toán小程序 bị vô hiệu hóa",
    "SRZFJE": "Nhập số tiền thanh toán",
    "FuKuanZhangHu": "Tài khoản thanh toán",
    "QueRenZhiFu": "Xác nhận thanh toán",
    "ShaoHouZhiFu": "Thanh toán sau",
//order
    "FKJLYTJ_DD": "Lịch sử thanh toán đã được thêm, đợi kiểm duyệt tài chính",
    "JiXuGuang": "Tiếp tục逛",
    "BenCiFuKuan": "Thanh toán lần này",
    "FuKuanChengGong": "Thanh toán thành công",
    "ZhiFuFangShi": "Phương thức thanh toán",
    "ZhiFuDingDan": "Thanh toán đơn hàng",
//order-batch-pay
    "QXXZSXZFDD": "Vui lòng chọn đơn hàng cần thanh toán trước",
    "PiLiangFuKuan": "Thanh toán hàng loạt",
    "FuKuan": "Thanh toán",
    "'QuFuKuan'": "Đi thanh toán",
//order-create-result
    "YingFuJinE": "Số tiền phải trả",
    "XiaDanShiJian": "Thời gian đặt hàng",
//order-deliver
    "SFQRSH": "Có chắc chắn muốn xác nhận nhận hàng không？",
    "DDQRSH_": "Xác nhận nhận hàng đơn hàng？",
    "DFHSP": "Sản phẩm chờ giao hàng",
    "ShangPinShuLiang": "Số lượng sản phẩm",
    "ChuKuShiJian": "Thời gian xuất kho",
    "FaHuoShiJian": "Thời gian giao hàng",
    "WuLiuBeiZhu": "Ghi chú logistics",
    "QueRenShouHuo": "Xác nhận nhận hàng",
    "RYFK_QJSYG": "Nếu đã thanh toán, vui lòng liên hệ quản trị viên kịp thời",
    "QSRQXYY": "Vui lòng nhập lý do hủy",
    "H_DDJZDGB_QJKF": "sau, đơn hàng sẽ tự động đóng, vui lòng thanh toán sớm",
    "TuiHuoQingKuang": "Tình hình trả hàng",
    "DingDanZongE": "Tổng số đơn hàng",
    "DingDanBeiZhu": "Ghi chú đơn hàng",
    "FaHuoQingKuang": "Tình hình giao hàng",
    "DingDanFuJian": "Đính kèm đơn hàng",
    "ShenQingTuiHuo": "Yêu cầu trả hàng",
    "G1TDSHJL_QRS": "Tổng cộng {num} bản ghi chờ nhận hàng, xác nhận nhận hàng không？",
    "DaiXiaDan": "Đặt hàng thay",
    "DingDanHao": "Số đơn hàng",
    "XiaDanFangShi": "Phương thức đặt hàng",
    "TuiHuoDan": "Đơn trả hàng",
    "ShangPinZongE": "Tổng giá sản phẩm",
    "YunFei_ZongZhong": "Phí vận chuyển (tổng trọng lượng",
    "SF_SPWS": "Phí thuế (sản phẩm không có thuế",
    "TePiJia": "Giá đặc biệt",
    "FuKuanQingKuang": "Tình hình thanh toán",
    "TiaoJiLu": "bản ghi",
    "ZaiLaiYiDan": "Đặt lại một đơn",
    "QDSCGDD_": "Chắc chắn muốn xóa đơn hàng này？",
    "YiQueRen": "Đã xác nhận",
    "YiShouHuo": "Đã nhận hàng",
    "DaiFuJinE": "Số tiền chờ thanh toán",
    "YiFuJinE": "Số tiền đã thanh toán",
    "ZanWuJiLu": "Không có bản ghi",
    "SPMC_DDH": "Tên sản phẩm / Số đơn hàng",
    "FuKuanZhuangTai": "Trạng thái thanh toán",
    "FaHuoZhuangTai": "Trạng thái giao hàng",
    "QiShiShiJian": "Thời gian bắt đầu",
    "ZhongZhiShiJian": "Thời gian kết thúc",
//order-list
    "CaoZuoChengGong": "Thao tác thành công",
    "ZBKGM": "Tạm không thể mua",
    "DQDDSPYXJ": "Sản phẩm đơn hàng hiện tại đã下架",
    "DQDDBFSPYXJ": "Một phần sản phẩm đơn hàng hiện tại đã下架",
    "JTJSJSP": "Chỉ thêm sản phẩm đã đăng bán",
    "DingHuoDan": "Đơn đặt hàng",
//order-log
    "DingDanRiZhi": "Nhật ký đơn hàng",
//order-logistics
    "FuZhiChengGong": "Sao chép thành công",
    "FuZhiShiBai": "Sao chép thất bại",
    "FuZhi": "Sao chép",
    "BoDa": "Gọi",
    "WCWLDHXX": "Không có thông tin số đơn logistics này",
//order-pay
    "ZFCS_QCXXD": "Thanh toán hết thời gian, vui lòng đặt hàng lại",
    "YQYYCKZF": "Đã启用 thanh toán tiền đặt cọc",
    "BNDYDFKJE": "Không thể lớn hơn số tiền chờ thanh toán",
    "ZFJEBNWK": "Số tiền thanh toán không được để trống",
    "QXAPFK_FKH": "Vui lòng sắp xếp thanh toán trước, sau khi thanh toán, chụp màn hình và tải lên thông tin thanh toán, để tài chính xác nhận số tiền",
    "DDTJCG_QJS": "Đơn hàng gửi thành công, vui lòng thanh toán kịp thời",
    "QXZFKFS": "Vui lòng chọn phương thức thanh toán",
    "SYYEZFH_HX": "Sau khi sử dụng thanh toán số dư, còn phải thanh toán",
//
    "FuKuanJiLu": "Lịch sử thanh toán",
    "ZWFKJL": "Không có lịch sử thanh toán",
    "FuKuanXiangQing": "Chi tiết thanh toán",
    "FuKuanJinE": "Số tiền thanh toán",
    "ZhiDan": "Lập đơn",
    "ShenHe": "Kiểm duyệt",
    "ZuoFei": "Hủy",
    "ZuoFeiYuanYin": "Lý do hủy",
    "GLDHD": "Liên kết đơn đặt hàng",
    "HeXiaoJinE": "Số tiền kiểm toán",
    "HeXiaoZhuangTai": "Trạng thái kiểm toán",
    "DanJuZhuangTai": "Trạng thái chứng từ",
    "KeHuMingCheng": "Tên khách hàng",
    "ZhangDanHao": "Số hóa đơn",
    "ShouKuanZhangHao": "Tài khoản nhận tiền",
    "ShouKuanShiJian": "Thời gian nhận tiền",
    "FuKuanPingZheng": "Chứng từ thanh toán",
    "GeFuJian": "tệp đính kèm",
//order-statistics
    "DingDanTongJi": "Thống kê đơn hàng",
    "DingHuo": "Đặt hàng",
    "Bi": "bản",
//order-statistics-detail
    "DDTJMX": "Chi tiết thống kê đơn hàng",
    "AGGTJ": "Thống kê theo quy cách",
    "AFLTJ": "Thống kê theo phân loại",
    "DDJE_Y": "Số tiền đơn hàng/đồng",
    "DHSP_Z": "Sản phẩm đặt hàng/loại",
    "DingHuoDan_Bi": "Đơn đặt hàng/bản",
    "DingHuoShangPin": "Sản phẩm đặt hàng",
    "JinE": "Số tiền",
//refund-list
    "TuiHuo": "Trả hàng",
//refund-apply
    "THDHWBC_QD": "Đơn trả hàng chưa được lưu, chắc chắn muốn rời khỏi？",
    "QSRSQTHJE": "Vui lòng nhập số tiền yêu cầu trả hàng",
    "QSRTHJE": "Vui lòng nhập số tiền trả hàng",
    "QSRBZXX": "Vui lòng nhập thông tin ghi chú",
    "YingTuiJinE": "Số tiền phải hoàn lại",
    "TJTHSQ": "Gửi yêu cầu trả hàng",
    "QXXZDHQD": "Vui lòng chọn danh sách đặt hàng trước",
    "DingHuoQingDan": "Danh sách đặt hàng",
    "SQTHJE": "Số tiền yêu cầu trả hàng",
    "DJXZSP": "Click để chọn sản phẩm",
    "TuiHuoJinE": "Số tiền trả hàng",
//refund-detail
    "THDDXQ": "Chi tiết đơn trả hàng",
    "YiTuiHuo": "Đã trả hàng",
    "YiTuiKuan": "Đã hoàn lại tiền",
    "THDZT": "Trạng thái đơn trả hàng",
    "TuiHuoDanHao": "Số đơn trả hàng",
    "TuiHuoShiJian": "Thời gian trả hàng",
    "TuiHuoCangKu": "Kho trả hàng",
    "THLXR": "Người liên hệ trả hàng",
    "TuiHuoQingDan": "Danh sách trả hàng",
    "TuiKuanZongE": "Tổng số tiền hoàn lại",
    "TuiKuanQingKuang": "Tình hình hoàn lại tiền",
    "DaiTuiJinE": "Số tiền chờ hoàn lại",
    "YiTuiJinE": "Số tiền đã hoàn lại",
//refund-product
    "SPMC_BH_GG": "Tên sản phẩm / Mã số / Mã quy cách / Mã vạch",
    "GZD1TJG": "Tổng cộng tìm thấy 1 kết quả",
    "JiaRuQingDan": "Thêm vào danh sách",
//refund-result
    "ShenQingChengGong": "Yêu cầu thành công",
    "THDTJCG": "Đơn trả hàng gửi thành công",
    "ChaKanXiangQing": "Xem chi tiết",
//goods-package-floor
    "HDWKS_WDZL": "Hoạt động chưa bắt đầu, quay lại sau nhé",
    "HDYJS_XCZD": "Hoạt động đã kết thúc, đến sớm hơn下次 nhé",
    "ZWSZBT": "Tạm chưa thiết lập tiêu đề",
    "ChaKanGengDuo": "Xem thêm",
//goods-promotion-floor
    "HCDZSJC": "Chênh lệch thời gian do bộ nhớ cache gây ra",
    "DLCKCXJ": "Đăng nhập để xem giá khuyến mãi",
    "ZWSZCX": "Tạm chưa thiết lập khuyến mãi",
    "JuKaiShi": "Còn lại đến khi bắt đầu",
    "Song": "Tặng",
    "JuJieShu": "Còn lại đến khi kết thúc",
    "YiJieShu": "Đã kết thúc",
//search-floor
    "XiaoXi": "Thông báo",
    "SaoMaXiaDan": "Quét mã để đặt hàng",
//home-page-custom
    "WZLCSJ": "Dữ liệu tầng không xác định",
//jump-error
    "QXZYSDHAPP": "Vui lòng tải ứng dụng Yunshang Order",
    "QMTYQYGLD": "Trải nghiệm đầy đủ端 quản lý doanh nghiệp",
    "XZYSDHAPP": "Tải ứng dụng Yunshang Order",
    "HQGLDWZTY": "Lấy trải nghiệm đầy đủ端 quản lý",
    "JXTYDHD": "Tiếp tục trải nghiệm端 đặt hàng",
    //notice-detail
    "GongGaoXiangQing": "Chi tiết thông báo",
    "GongGaoFuJian": "Tệp đính kèm thông báo",
//shop-error
    "NFWDYMBCZO": "Trang bạn truy cập không tồn tại~",
    "KeNengYuanYin": "Nguyên nhân có thể",
    "1_ZDZLSRCWD": "1. Nhập sai địa chỉ trong thanh địa chỉ;",
    "2_DJLGQLJ": "2. Nhấp vào liên kết đã hết hạn.",
//shop-index
    "GuanLiDuan": "Giao diện quản lý",
    "ZhuCe": "Đăng ký",
    "HYNTYYSDH": "Chào mừng bạn trải nghiệm Yunshang Order",
    "TYZHSJHDQG": "Dữ liệu tài khoản thử nghiệm sẽ cập nhật định kỳ, đừng nhập thông tin quan trọng",
    "TYZHZDNRSJ": "Tất cả dữ liệu nội dung trong tài khoản thử nghiệm đều giả định, đừng nhập thông tin quan trọng",
    "ZHZCCG": "Đăng ký tài khoản thành công",
    "DengLuZhangHao": "Tài khoản đăng nhập",
    "CSMMW": "Mật khẩu ban đầu là",
    "GNFYHQL": "Chúng tôi đã gửi phiếu ưu đãi cho bạn!",
    "Man1YuanKeYong": "Có thể dùng khi đủ {num} Yuan",
    "LQH1TNKY": "Có thể dùng trong {day} ngày sau khi nhận phiếu",
    "YiJianLingQu": "Nhận ngay với 1 click",
    "GXNHD1ZYHQ": "Chúc mừng bạn nhận được 1 phiếu ưu đãi",
    "Gong1Yuan": "Tổng 1 Yuan",
    "LiJiShiYong": "Sử dụng ngay",
//shop-login
    "NHWDL": "Bạn chưa đăng nhập",
//shop-notice
    "ShangChengGongGao": "Thông báo của trung tâm mua sắm",
    "ZanWuGongGao": "Chưa có thông báo",
    "1GeFuJian": "{num} tệp đính kèm",
//deposit-detail
    "KouKuan": "Trừ tiền",
    "ChongZhi_Kuan": "Nạp tiền",
    "KouKuanZuoFei": "Hủy trừ tiền",
    "ChongZhiZuoFei": "Hủy nạp tiền",
    "ZhangHuMingXi": "Chi tiết tài khoản",
    "ZhangHuYuE": "Số dư tài khoản",
    "LiJiChongZhi": "Nạp tiền ngay",
//deposit-recharge
    "CZJEBNXY1Y": "Số tiền nạp không thể nhỏ hơn 1 Yuan",
    "QSRZQDSZ": "Vui lòng nhập giá trị đúng",
    "ZDYJE": "Số tiền tùy chỉnh",
    "ZWKTXSCZGN": "Chưa mở chức năng nạp tiền trực tuyến",
    "ShiFuJinE": "Số tiền thực tế trả",
    "ZhangHuChongZhi": "Nạp tiền vào tài khoản",
    "QXZCZJE": "Vui lòng chọn số tiền nạp",
    "QSRCZJE": "Vui lòng nhập số tiền nạp",
    "QLXNDZSYWY": "Vui lòng liên hệ nhân viên kinh doanh专属 để nạp tiền",
    "ShouJia": "Giá bán",
    "YiShouQing": "Đã bán hết",
    "ChongZhiJinE": "Số tiền nạp",
    "QueRenFuKuan": "Xác nhận thanh toán",
//deposit-recharge-result
    "QSDDID": "Thiếu ID đơn hàng",
    "ChongZhiChengGong": "Nạp tiền thành công",
    "ChongZhiShiBai": "Nạp tiền thất bại",
    "CLZ_QSH...": "Đang xử lý, vui lòng chờ...",
    "ChongZhiFangShi": "Phương thức nạp tiền",
    "ChongZhiShiJian": "Thời gian nạp tiền",
    "JYLSH": "Số giao dịch",
    "FanHuiShangCheng": "Quay lại trung tâm mua sắm",
//recharge-online
    "ZFSB_QCS": "Thanh toán thất bại, vui lòng thử lại",
    "ZFYQX": "Đã hủy thanh toán",
    "ZFYC_QCS": "Thanh toán có ngoại lệ, vui lòng thử lại",
//user
    "LingQuanZhongXin": "Trung tâm nhận phiếu",
    "WeiShiYong": "Chưa sử dụng",
    "YiShiYong": "Đã sử dụng",
    "ZWYHQ": "Chưa có phiếu ưu đãi",
//keep-list
    "YiGouMai": "Đã mua",
    "ChangYongQingDan": "Danh sách thường dùng",
    "WoDeShouCang": "Bộ sưu tập của tôi",
    "QuGouWuChe": "Đi đến giỏ hàng",
    "GeShangPin": "sản phẩm",
//login
    "YunShangDingHuo": "Yunshang Order",
    "QSRZH": "Vui lòng nhập tài khoản!",
    "QSRMM": "Vui lòng nhập mật khẩu!",
    "QSRDLZH": "Vui lòng nhập tài khoản đăng nhập",
    "JiZhuMiMa": "Ghi nhớ mật khẩu",
    "WangJiMiMa": "Quên mật khẩu?",
    "DengLu": "Đăng nhập",
    "DLZHBCZ_QL": "Tài khoản đăng nhập không tồn tại, vui lòng liên hệ quản trị viên để mở",
    "GQYZHSBJY_": "Tài khoản doanh nghiệp này bị vô hiệu hóa, vui lòng liên hệ Yunshang Order",
    "GQYZHSYQJS_": "Thời gian thử nghiệm tài khoản doanh nghiệp này kết thúc, vui lòng liên hệ Yunshang Order",
    "GQYZHYGQL_": "Tài khoản doanh nghiệp này đã hết hạn, cần gia hạn để sử dụng, vui lòng liên hệ Yunshang Order",
    "LiJiTiYan": "Trải nghiệm ngay",
//my-collect
    "YiChuChengGong": "Xóa thành công",
    "QueHuo": "Hết hàng",
    "YCSCJ": "Xóa khỏi bộ sưu tập",
//order-message
    "SheZhiChengGong": "Cài đặt thành công",
    "ZWWDXX": "Chưa có tin nhắn chưa đọc",
    "QuanBuYiDu": "Đánh dấu tất cả đã đọc",
    "DingDanXiaoXi": "Tin nhắn đơn hàng",
    "YiQiang": "Đã nhận",
    "LiJiLingQu": "Nhận ngay",
    "LingQuanHou": "Sau khi nhận phiếu",
    "TianNeiKeYong": "ngày nội có thể dùng",
    "QSRSJH": "Vui lòng nhập số điện thoại",
    "QSRYZM": "Vui lòng nhập mã xác minh",
    "QSRXMM": "Vui lòng nhập mật khẩu mới",
    "QSRZQSJGS": "Vui lòng nhập định dạng số điện thoại đúng",
    "ChongZhiMiMa": "Đặt lại mật khẩu",
    "QSRNDSJHM": "Vui lòng nhập số điện thoại của bạn",
    "QSRDXYZ": "Vui lòng nhập mã xác minh tin nhắn",
    "HQYZM": "Lấy mã xác minh",
    "HKCXHQ": "Có thể lấy lại sau",
    "QSR6_20WSZHZ": "Vui lòng nhập mật khẩu 6-20 ký tự (số hoặc chữ)",
//share-setting
    "QSRSPJGBL": "Vui lòng nhập tỷ lệ giá sản phẩm",
    "SPJGBLBXDY": "Tỷ lệ giá sản phẩm phải ≥100 và <999.99",
    "DPMCZBZCTS": "Tên cửa hàng chưa hỗ trợ ký tự đặc biệt",
    "LXRZBZCTSF": "Người liên hệ chưa hỗ trợ ký tự đặc biệt",
    "LXFSZBZCTS": "Phương thức liên hệ chưa hỗ trợ ký tự đặc biệt",
    "LXDZZBZCTS": "Địa chỉ liên hệ chưa hỗ trợ ký tự đặc biệt",
    "DPJJZBZCTS": "Giới thiệu cửa hàng chưa hỗ trợ ký tự đặc biệt",
    "QSRDPJJ_ZD": "Vui lòng nhập giới thiệu cửa hàng, tối đa 50 ký tự",
    "FenXiangSheZhi": "Cài đặt chia sẻ",
    "NDWSCSPJG": "Giá sản phẩm trung tâm mua sắm micro của bạn",
    "NDDHJ_": "Giá đặt hàng của bạn ×",
    "LXXX_KBJ_": "Thông tin liên hệ (có thể chỉnh sửa）",
    "DianPuMingCheng": "Tên cửa hàng",
    "JianJie": "Giới thiệu",
    "QSRDPMC": "Vui lòng nhập tên cửa hàng",
    "LianXiRen": "Người liên hệ",
    "QSRLXR": "Vui lòng nhập người liên hệ",
    "LianXiFangShi": "Phương thức liên hệ",
    "QSRLXFS": "Vui lòng nhập phương thức liên hệ",
    "LianXiDiZhi": "Địa chỉ liên hệ",
    "QSRLXDZ": "Vui lòng nhập địa chỉ liên hệ",
//user
    "WoDeDingDan": "Đơn hàng của tôi",
    "ZuiJinLiuLan": "Đã xem gần đây",
    "ShouCangShangPin": "Sản phẩm được lưu",
    "BDYYZH_ZC": "Liên kết tài khoản hiện có | Đăng ký tài khoản mới",
    "DL_ZC": "Đăng nhập | Đăng ký",
    "BangDingShouJi": "Liên kết điện thoại",
    "TS_BDSJHM_": "Lưu ý: Liên kết số điện thoại để tài khoản an toàn hơn!",
    "ChaKanQuanBu": "Xem tất cả",
    "ShouHuoDiZhi": "Địa chỉ nhận hàng",
    "LianXiWoMen": "Liên hệ chúng tôi",
    "SheZhi": "Cài đặt",
    "QuQianDao": "Đi check-in",
    "JiFenShangCheng": "Trung tâm mua sắm điểm",
    "TuiGuangShangPin": "Quảng bá sản phẩm",
    "QuChaKan": "Đi xem",
    "JiFenHuanLi": "Đổi quà bằng điểm",
    "DYSPBQ": "In nhãn sản phẩm",
//user-about
    "GYYSDH": "Về Yunshang Order",
    "YQHYSMEWM_": "Mời bạn bè quét mã QR, tải và cài đặt trực tiếp",
    "DangQianBanBen": "Phiên bản hiện tại",
//user-address
    "ZWSHDZ": "Chưa có địa chỉ nhận hàng",
    "WoDeDiZhi": "Địa chỉ của tôi",
    "ZhiNengShiBie": "Nhận diện thông minh",
    "ZTDZXXKZNS": "Dán thông tin địa chỉ để nhận diện tên, số điện thoại, địa chỉ tự động",
    "MoRen": "Mặc định",
    "QRSCDZ": "Xác nhận xóa địa chỉ?",
    "SHRXM": "Tên người nhận",
    "SJHMHGDDHZ": "Phải nhập ít nhất một trong số điện thoại di động hoặc cố định",
    "QSRSHRXM": "Vui lòng nhập tên người nhận",
    "ShouJiHaoMa": "Số điện thoại di động",
    "GuDingDianHua": "Điện thoại cố định",
    "QSRGDDH": "Vui lòng nhập điện thoại cố định",
    "SuoZaiDiQu": "Khu vực đang ở",
    "QSRSZDQ": "Vui lòng nhập khu vực đang ở",
    "QSRXXDZ": "Vui lòng nhập địa chỉ chi tiết!",
    "QSRZQDSJHM": "Vui lòng nhập số điện thoại di động đúng",
    "QSRZQDGDDH": "Vui lòng nhập điện thoại cố định đúng",
    "XiangXiDiZhi": "Địa chỉ chi tiết",
    "MoRenDiZhi": "Địa chỉ mặc định",
    "SWMRDZ": "Đặt làm địa chỉ mặc định",
    "BCBSY": "Lưu và sử dụng",
//user-bing-one
    "QSRSJHM": "Vui lòng nhập số điện thoại",
    "GYHYZC": "Người dùng này đã đăng ký",
    "GSJHMYJZCG": "Số điện thoại này đã được đăng ký",
    "QZJDLJK": "Vui lòng đăng nhập trực tiếp",
    "QuDengLu": "Đi đăng nhập",
    "BDHKYTGSJH": "Sau khi liên kết, có thể đăng nhập qua số điện thoại, dễ dàng lấy lại mật khẩu, tăng độ an toàn tài khoản",
    "_BDHKYTGSJ": "*Sau khi liên kết, có thể đăng nhập qua số điện thoại, dễ dàng lấy lại mật khẩu, tăng độ an toàn tài khoản",
    "QSRSJYZM": "Vui lòng nhập mã xác minh điện thoại",
    "BDXSJ": "Liên kết điện thoại mới",
    "DXYZM": "Mã xác minh tin nhắn",
    "XiaYiBu": "Bước tiếp theo",
    "TGCBZ": "Bỏ qua bước này",
//user-bing-two
    "DBDSJHMBCZ": "Số điện thoại sẽ liên kết không tồn tại!",
    "QSRDLMM": "Vui lòng nhập mật khẩu đăng nhập!",
    "_GSJHMYBDY": "*Số điện thoại này đã liên kết với tài khoản Yunshang Order, xác minh mật khẩu đăng nhập điện thoại để liên kết tài khoản hiện tại",
    "DQZHMMJTBW": "Mật khẩu tài khoản hiện tại sẽ đồng bộ thành mật khẩu đăng nhập điện thoại",
    "DangQianZhangHao": "Tài khoản hiện tại",
//
    "QDYJZ": "Xác nhận xóa",
    "JSPSCM": "sản phẩm này?",
    "ShanChuChengGong": "Xóa thành công!",
//user-info
    "SJGSCW": "Định dạng điện thoại sai",
    "YXGSCW": "Định dạng email sai",
    "WoDeZhangHao": "Tài khoản của tôi",
    "YouXiang": "Email",
    "ShouJi": "Điện thoại",
    "XingMing": "Tên",
    "XiuGaiTouXiang": "Chỉnh sửa ảnh đại diện",
    "JiBenXinXi": "Thông tin cơ bản",
    "ZhangHaoAnQuan": "An toàn tài khoản",
    "XiuGaiMiMa": "Chỉnh sửa mật khẩu",
    "DianJiBangDing": "Nhấp để liên kết",
    "RYDSHTY_QL": "Nếu mất hoặc ngừng sử dụng, vui lòng thay đổi ngay để tránh tài khoản bị đánh cắp",
    "WBZNDZHAQ_": "Để bảo vệ an toàn tài khoản, vui lòng liên kết điện thoại",
    "QSRNDXM": "Vui lòng nhập tên của bạn",
    "QSRNDDH": "Vui lòng nhập số điện thoại của bạn",
    "QSRNDYX": "Vui lòng nhập email",
//user-setting
    "QCHCHXCXDL": "Sau khi xóa cache, cần đăng nhập lại",
    "QingChuHuanCun": "Xóa cache",
    "QDYQCHCM": "Xác nhận xóa cache?",
    "TuiChuDengLu": "Đăng xuất",
    "QieHuanZhangHao": "Chuyển tài khoản",
//user-supplier
    "LianXi": "Liên hệ",
    "GongSiDianHua": "Số điện thoại công ty",
    "DiZhi": "Địa chỉ",
//vouchers-detail
    "DJQMX": "Chi tiết phiếu giảm giá",
//vouchers-list
    "BuKeYong": "Không thể dùng",
    "KeYong": "Có thể dùng",
    "ZWDJQ": "Chưa có phiếu giảm giá",
    "ZongEDu": "Tổng mức",
    "FaFangShiJian": "Thời gian phát hành",
    "EDYYW": "Mức đã dùng hết",
    "QBSPKY": "Có thể dùng cho tất cả sản phẩm",
//vouchers-select-list
    "WDDJQ": "Phiếu giảm giá của tôi",
    "KYDJQ": "Phiếu giảm giá có thể dùng",
    "DJQKDK": "Phiếu giảm giá có thể trừ",
    "CKKYSP": "Xem sản phẩm có thể dùng",
    "BKYDJQ": "Phiếu giảm giá không thể dùng",
    "BKYYY_ZWFH": "Lý do không dùng được: Chưa có sản phẩm phù hợp",
//goods-detail
    "DQSPWSCGGT": "Sản phẩm hiện tại chưa tải ảnh quy cách, không hỗ trợ cài đèn!",
    "BoFangShiPin": "Phát video",
    "Gong1GeGuiGe": "Tổng {num} quy cách",
    "YiXuanGuiGe": "Quy cách đã chọn",
    "XuanGuiGe": "Chọn quy cách",
    "LingQuan": "Nhận phiếu",
    "1ZhongCuXiao": "1 chương trình khuyến mãi",
    "1ZhangKeYong": "1 phiếu có thể dùng",
    "ZuiGaoKeSheng": "Tiết kiệm tối đa",
    "ShangPinTaoCan": "Gói sản phẩm",
    "Gong1GeTaoCan": "Tổng 1 gói",
    "ShangPinCanShu": "Thông số sản phẩm",
    "ZhanKai": "Mở rộng",
    "YiShouCang": "Đã lưu",
    "ShouCang": "Lưu",
    "KeFu": "Hỗ trợ khách hàng",
    "XiangQing": "Chi tiết",
    "TuiJian": "Đề xuất",
    "BianHao": "Mã số",
    "ShangPinXinXi": "Thông tin sản phẩm",
    "KLYHQ": "Có thể nhận phiếu ưu đãi",
    "KuCunBuZu": "Kho không đủ",
    "DuoGuiGe": "Nhiều quy cách",
    "YiShou": "Đã bán",
    "SWBHZ_YS": "Đang bổ sung hàng, đã bán",
    "CuXiaoShangPin": "Sản phẩm khuyến mãi",
//goods-search
    "NHWSRSSNR": "Bạn chưa nhập nội dung tìm kiếm",
    "SouSuo": "Tìm kiếm",
    "SSY1XGDSP": "Tìm sản phẩm liên quan đến {searchKey}",
    "Yue1GeShangPin": "Khoảng {num} sản phẩm",
    "ZuiJinSouSuo": "Tìm kiếm gần đây",
    "QingChu": "Xóa",
    "ZWSSJL": "Chưa có lịch sử tìm kiếm",
//goods-property
    "ZGJGBNDYZD": "Giá cao nhất không thể thấp hơn giá thấp nhất",
    "ShangPinBiaoQian": "Nhãn sản phẩm",
    "BuGaoYu1": "Không cao hơn 1",
    "BuDiYu1": "Không thấp hơn 1",
    "FengGe": "Phong cách",
//goods-promotion-list
    "JiJiangKaiShi": "Sắp bắt đầu",
    "QuanBuCuXiao": "Tất cả khuyến mãi",
//goods-package-list
    "Gong1JianShangPin": "Tổng 1 sản phẩm",
    "Sheng": "Tiết kiệm",
//goods-package-detail
    "GTCZGWCZDS": "Số lượng gói trong giỏ hàng đã đạt giới hạn mua, không thể thêm vào giỏ hàng",
    "GTCKCBZ_BK": "Kho gói này không đủ, không thể thêm vào giỏ hàng",
    "JinSheng1Tao": "Chỉ còn 1 gói",
    "XianGou1Tao": "Giới hạn mua 1 gói",
    "TaoCanXiangQing": "Chi tiết gói",
    "DanMaiJia": "Giá mua lẻ",
    "TaoCanJia": "Giá gói",
    "HDYJS": "Hoạt động đã kết thúc",
//goods-message
    "WDL_QXDL": "Chưa đăng nhập, vui lòng đăng nhập trước",
//goods-list-label
    "XinPinShangShi": "Sản phẩm mới ra mắt",
    "WDLZH_ZWCX": "Chưa đăng nhập tài khoản, chưa có hoạt động khuyến mãi!",
    "YiXiaShangPin": "Sản phẩm dưới đây",
//goods-list
    "1ZhongGuiGe": "1 quy cách",
    "YouKuCun": "Có trong kho",
//goods-filter
    "BuGaoYu": "Không cao hơn",
    "BuDiYu": "Không thấp hơn",
    "CuXiao": "Khuyến mãi",
    "ZDYXXZ3G": "Tối đa chọn 3",
    "GouMai": "Mua",
    "Gong1Jian": "Tổng {num} sản phẩm",
//已订货商品
    "DLHCKJG": "Đăng nhập để xem giá",
    "M1JZ1J": "Tặng {presentNum} sản phẩm khi đủ {num} sản phẩm",
    "CZPF_ZZCXC": "Thao tác quá nhiều, đang thử lại",
    "XSZJJXZ": "Đang chạy chương trình giảm giá giới hạn thời gian",
    "YXSPM1YZ1J_": "Sản phẩm dưới đây {str}, thêm vào giỏ hàng thanh toán để hưởng ưu đãi!",
    "TiaoXingMa": "Mã vạch",
    "XiangGuanTuiJian": "Đề xuất liên quan",
    "YSSPBKJRGW": "Sản phẩm đặt trước không thể thêm vào giỏ hàng, đã thêm sản phẩm không đặt trước cho bạn!",
    "YSSPBKLJGM": "Sản phẩm đặt trước không thể mua ngay, vui lòng xóa sản phẩm đặt trước rồi mua lại!",
    "SPSLYW": "Số lượng sản phẩm sai",
    "ShangPin1QiShou": "Sản phẩm bắt đầu bán từ {num}",
    "SPDGSLBNCG": "Số lượng đặt sản phẩm không thể quá {num}",
    "QRYCXZSP": "Xác nhận xóa sản phẩm đã chọn",
    "QRYCSYSXSP": "Xác nhận xóa tất cả sản phẩm hết hiệu lực",
    "QRYCXZSXSP": "Xác nhận xóa sản phẩm hết hiệu lực đã chọn",
    "M1YZ1J": "Tặng {presentNum} sản phẩm khi đủ {num} Yuan",
    "M1YJ1Y": "Giảm {money} Yuan khi đủ {price} Yuan",
    "M1J1": "Giảm {money} khi đủ {price}",
    "M1YD1Z": "Giảm {money}折 khi đủ {price} Yuan",
    "DDM1YHZ": "Đơn hàng tặng khi đủ {price} Yuan",
    "YiHuoZeng": "Đã nhận tặng",
    "ZG1YLXM1YZ1": "Mua thêm {price} Yuan để hưởng {str}",
    "ZG1JLXM1JZ1": "Mua thêm {num} sản phẩm để hưởng {str}",
    "QCSXSP": "Xóa sản phẩm hết hiệu lực",
    "YiXuanShangPin": "Sản phẩm đã chọn",
    "QuJieSuan": "Đi thanh toán",
    "ShiXiaoShangPin": "Sản phẩm hết hiệu lực",
    "DingDanGuanLi": "Quản lý đơn hàng",
    "ZhuangTai": "Trạng thái",
    "ShangPinChuKu": "Xuất kho sản phẩm",
    "DengDaiShouHuo": "Chờ nhận hàng",
    "PeiSongXinXi": "Thông tin giao hàng",
    "FuKuanXinXi": "Thông tin thanh toán",
    "GDFKJL": "Xem thêm lịch sử thanh toán",
    "WuLiuFuJian": "Tệp đính kèm logistics",
    "ZanWuFuJian": "Chưa có tệp đính kèm",
    "YiFa": "Đã gửi",
    "YingFuZongE": "Tổng số tiền phải trả",
    "FuKuanShiJian": "Thời gian thanh toán",
    "ZhangHuHaoMa": "Số tài khoản",
    "KeYongYuE": "Số dư có thể dùng",
    "TianJiaChengGong": "Thêm thành công",
    "ShanChuDiZhi": "Xóa địa chỉ",
    "QXZSHDZ": "Vui lòng chọn địa chỉ nhận hàng",
    "YiHuoZengPin": "Đã nhận sản phẩm tặng",
    "YiYouHui1Yuan": "Đã ưu đãi {money} Yuan",
    "QWSFPXX": "Vui lòng hoàn thiện thông tin hóa đơn",
    "1ZSP": "{num} loại sản phẩm",
    "Gong": "Tổng",
    "Jian": "sản phẩm",
    "ShangPinJinE": "Số tiền sản phẩm",
    "YunFeiDaoFu": "Phí vận chuyển thu khi giao hàng",
    "QSRZQDSHRX": "Vui lòng nhập tên người nhận đúng",
    "QSRZQDXXDZ": "Vui lòng nhập địa chỉ chi tiết đúng",
    "DBQ_MYZDDY": "Xin lỗi, không tìm thấy trang tương ứng",
    "ShouHuoChengGong": "Nhận hàng thành công",
    "Hi_HuanYingNin": "Hi, chào mừng bạn",
    "YiFaEWuLiu": "Đã gửi logistics e",
    "NinDeDingDan": "Đơn hàng của bạn",
    "ZBNBHBQ": "không thể chứa biểu tượng cảm xúc",
    "XMBNWK": "Tên không thể để trống",
    "XiTongSheZhi": "Cài đặt hệ thống",
    "ZhangHaoXinXi": "Thông tin tài khoản",
    "QingShuRuXingMing": "Vui lòng nhập tên",
    "QWSZL_JZYG": "Vui lòng hoàn thiện hồ sơ, giúp chúng tôi phục vụ bạn tốt hơn",
    "QSRZQDYXGS": "Vui lòng nhập định dạng email đúng",
    "QTXZQDCWXX": "Vui lòng điền thông tin tài chính đúng, để đối tác của bạn phát hóa đơn cho bạn",
    "GXSHDZCG": "Cập nhật địa chỉ nhận hàng thành công",
    "BCSHDZCG": "Lưu địa chỉ nhận hàng thành công",
    "XinZengDiZhi": "Thêm địa chỉ mới",
    "QXZYQXSCDS": "Vui lòng chọn sản phẩm sẽ hủy lưu",
    "QuXiaoShouCang": "Hủy lưu",
    "XuanZeGuiGe": "Chọn quy cách",
    "CaiWuGuanLi": "Quản lý tài chính",
    "DuiZhangMingXi": "Chi tiết đối soát tài khoản",
    "QSRLWJL_JE": "Vui lòng nhập lịch sử giao dịch/số tiền",
    "YiGouMai1Ci": "Đã mua {count} lần",
    "6_1GouMai": "{time} mua",
    "TZGGXQ": "Chi tiết thông báo",
    "ZYXSCSP": "Chỉ cho phép tải video",
    "SCSPDXBYXC": "Kích thước video tải lên không thể quá {size}",
    "YDHSP": "Sản phẩm đã đặt",
    "ShangPinPinPai": "Thương hiệu sản phẩm",
    "ShangPinLieBiao": "Danh sách sản phẩm",
    "LingShouJia": "Giá bán lẻ",
    "YouHuiJia": "Giá ưu đãi",
    "LiJiGouMai": "Mua ngay",
    "ZhuTu": "Hình ảnh chính",
    "WuXianZhi": "Không giới hạn",
    "XiaoJi": "Tổng phụ",
    "SCXZSP": "Xóa sản phẩm đã chọn",
    "QSRDDH": "Vui lòng nhập số đơn hàng",
    "QSRDDH_SPMC": "Vui lòng nhập số đơn hàng/tên sản phẩm",
    "CaoZuo": "Thao tác",
    "WuLiuXinXi": "Thông tin logistics",
    "CaoZuoLeiXing": "Loại thao tác",
    "CaoZuoRiZhi": "Lịch sử thao tác",
    "CaoZuoShiJian": "Thời gian thao tác",
    "ZhangHuMingCheng": "Tên tài khoản",
    "KaiHuYinHang": "Ngân hàng mở tài khoản",
    "DDTJCG_XZZC": "Đơn hàng gửi thành công, chỉ còn bước cuối cùng",
    "ZhiFuJinE": "Số tiền thanh toán",
    "DZFJE": "Số tiền chờ thanh toán",
    "QTXYXSMB": "Hãy điền một vài lời giải thích",
    "XZSKYHZH": "Chọn tài khoản ngân hàng nhận tiền",
    "TiShi": "Thông báo",
    "NHY1GDDGJ1Y": "Bạn còn {num} đơn hàng tổng {money} Yuan chưa thanh toán",
    "QKJQHCKJXX": "Phải thanh toán nợ xong mới có thể đặt hàng tiếp",
    "HDDDXX": "Kiểm tra thông tin đơn hàng",
    "BJSHDZ": "Chỉnh sửa địa chỉ nhận hàng",
    "TongZhiGongGao": "Thông báo và thông tin",
    "YinHangZhangHao": "Số tài khoản ngân hàng",
    "XiuGaiShouJi": "Chỉnh sửa điện thoại",
    "LXRXX": "Thông tin người liên hệ",
    "GSCWXX": "Thông tin tài chính công ty",
    "QSRKHYHMCJ": "Vui lòng nhập tên ngân hàng mở tài khoản và chi nhánh",
    "QSRYHZH": "Vui lòng nhập số tài khoản ngân hàng",
    "PiLiangCaoZuo": "Thao tác hàng loạt",
    "GouMaiJiLu": "Lịch sử mua hàng",
    "TongZhiBiaoTi": "Tiêu đề thông báo",
    "FaBuShiJian": "Thời gian đăng",
    "XiaoXiLeiXing": "Loại tin nhắn",
    "XiaoXiNeiRong": "Nội dung tin nhắn",
    "JieShouShiJian": "Thời gian nhận",
    "QuanBuPinPai": "Tất cả thương hiệu",
    "WXSYS_DHGBJ": "Quét QR WeChat, đặt hàng tiện lợi hơn",
    "GZWXGZH": "Theo dõi trang WeChat công khai",
    "FuWuReXian": "Hotline hỗ trợ",
    "SouSuoLiShi": "Lịch sử tìm kiếm",
    "QuanBuShanChu": "Xóa tất cả",
    "NH_HYLDYSDH": "Xin chào, chào mừng bạn đến {company}!",
    "ZSJDH": "Đặt hàng trên điện thoại",
    "SYS_GZWXGZH": "Quét QR, theo dõi trang WeChat công khai",
    "GuanZhuWoMen": "Theo dõi chúng tôi",
    "QBSPFL": "Tất cả danh mục sản phẩm",
    "QuPeiDeng": "Đi cài đèn",
    "KuanXiang": "Số tiền",
    "QSRSPMC_GG_": "Vui lòng nhập tên sản phẩm/quy cách/mã số/chữ cái đầu",
    "NH_HYLDYSD": "Xin chào, chào mừng bạn đến trung tâm mua sắm Yunshang Order!",
    "ReXiao": "Bán chạy",
    "20Tiao_Ye": "20条/trang",
    "ShiChangJia_": "Giá thị trường：",
    "_134.10Qi": "Từ S/ 134.10",
    "HJ_BHYF": "Tổng (không bao gồm phí vận chuyển)：",
    "QDSCXZSP_": "Xác nhận xóa sản phẩm đã chọn?",
    "QDQCXJSP_": "Xác nhận xóa sản phẩm đã下架?",
    "DDTJCG_XZZ": "Đơn hàng gửi thành công, chỉ còn bước cuối cùng!",
    "XuanZeZhangHu": "Chọn tài khoản",
    "DaiZhiFu": "Chờ thanh toán",
    "CaiGouDingDan": "Đơn mua hàng",
    "DingDanXinXi": "Thông tin đơn hàng",
    "TuiChu": "Thoát",
    "KaiHuMingCheng": "Tên người mở tài khoản",
    "QSRKHMC": "Vui lòng nhập tên người mở tài khoản",
    "_QTXZQDCWX": "（Vui lòng điền thông tin tài chính đúng, để đối tác của bạn phát hóa đơn cho bạn）",
    "ShouHuoRen": "Người nhận hàng",
    "SWMRSHDZ": "Đặt làm địa chỉ nhận hàng mặc định",
    "TianJiaDiZhi": "Thêm địa chỉ",
    "Gong4GeGuiGe": "Tổng 4 quy cách",
    "Zhi": "Chỉ",
    "Kuai": "khối",
    "Tou": "con",
    "Xiang": "hộp",
    "Ping": "chai",
    "KaiShiRiQi": "Ngày bắt đầu",
    "JieShouRiQi": "Ngày kết thúc",
    "YiXuan": "Đã chọn",
    "ZhiFuZhuangTai": "Trạng thái thanh toán",
    "QDLCKJG": "Vui lòng đăng nhập để xem giá",
    "YZMBZQ": "Mã xác minh không đúng",
    "ZhiFuJiLu": "Lịch sử thanh toán",
    "ShangPinMingCheng": "Tên sản phẩm",
    "DingGouShuLiang": "Số lượng đặt hàng",
    "TuiHuoShuLiang": "Số lượng trả hàng",
    "QSRTHNR": "Vui lòng nhập nội dung trả hàng",
    "SCTHSM": "Tải lên ghi chú trả hàng",
    "ShenQingShiJian": "Thời gian yêu cầu",
    "ShenQingJinE": "Số tiền yêu cầu",
    "TuiHuoYuanYin": "Nguyên nhân trả hàng",
    "TuiHuoShuoMing": "Ghi chú trả hàng",
    "TuiDanHao": "Số đơn trả hàng",
    "SXCZ_XDCG": "Tín dụng đủ, đặt hàng thành công",
    "SXEDBZ_FKHFH": "Tín dụng không đủ, giao hàng sau khi thanh toán",
    "CGJKZQ_FKFH": "Vượt quá kỳ hạn vay, giao hàng sau khi thanh toán",
    "DDTJCG_XZZCZHYB": "Đơn hàng gửi thành công, chỉ còn bước cuối cùng!",
    "QNZ_NWCFK_FZ": "Vui lòng hoàn thành thanh toán trong {time}, nếu không đơn hàng sẽ bị hủy tự động.",
    "MianFeiLing": "Nhận miễn phí",
    "M_KMFLQ_HQ": "Có thể nhận miễn phí khi đủ {target} Yuan, còn thiếu {short} Yuan",
    "YHDMFSP": "Đã nhận sản phẩm miễn phí",
    "JRMFL": "Nhận miễn phí hôm nay",
    "LingGuangLe": "Đã nhận hết",
    "KeLingQu": "Có thể nhận",
    "QSRZFJE": "Vui lòng nhập số tiền thanh toán",
    "QNJKFK_WMJKWNCL": "Vui lòng thanh toán sớm, chúng tôi sẽ xử lý đơn hàng của bạn sớm nhất!",
    "XianXiaTiYanGuan": "Trung tâm trải nghiệm trực tiếp",
    "QingXuanZheSheng": "Vui lòng chọn tỉnh",
    "QingXuanZheShi": "Vui lòng chọn thành phố",
    "ZhanGuanDiZhi": "Địa chỉ triển lãm",
    "YingYeShiJian": "Thời gian hoạt động",
    "ZhanGuanDianHua": "Số điện thoại triển lãm",
    "FenXiang": "Chia sẻ",
    "TiYanGuanJieShao": "Giới thiệu trung tâm trải nghiệm",
    "DPYDY_QSHX": "Cửa hàng đã đóng cửa, vui lòng đặt hàng sau",
    "DaYangShiJian": "Thời gian đóng cửa",
    "IMEI": "Mã IMEI",
    "FanKuanYuE": "Số dư hoàn tiền",
    "FanKuanZhiFu": "Thanh toán bằng hoàn tiền",
    "YiShengZhiFu": "Thanh toán Yisheng",
    "JiongDongShouYinTai": "Quầy thu tiền Jingdong",
    "FKYEBZ": "Số dư hoàn tiền không đủ",
    "FanKuanZhangHu": "Tài khoản hoàn tiền",
    "HaiXuZhiFu": "Còn phải thanh toán {price}",
    "FaPiaoMingXi": "Chi tiết hóa đơn",
    "FaPiaoZhuShou": "Trợ lý hóa đơn",
    "WoDeFaPiao": "Hóa đơn của tôi",
    "FaPiaoXiangQing": "Chi tiết hóa đơn",
    "KaiPiaoShiJian": "Thời gian phát hóa đơn",
    "DaiKaiFaPiao": "Hóa đơn chờ phát",
    "DKFPJE": "Số tiền hóa đơn chờ phát",
    "KaiPiaoJinE": "Số tiền hóa đơn",
    "GuanLianDanHao": "Số đơn liên kết",
    "ChuangJianShiJian": "Thời gian tạo",
    "ZhiFuPingZheng": "Chứng từ thanh toán",
    "QSRZQNR": "Vui lòng nhập nội dung đúng",
    "QSRTDH_SPMC": "Vui lòng nhập số đơn trả hàng/tên sản phẩm",
    "ShangPinRuKu": "Nhập kho sản phẩm",
    "TuiKuanChuLi": "Xử lý hoàn tiền",
    "YuanDingDanHao": "Số đơn hàng gốc",
    "TuiHuoXinXi": "Thông tin trả hàng",
    "TuiKuanXinXi": "Thông tin hoàn tiền",
    "TuiKuanZhuangTai": "Trạng thái hoàn tiền",
    "ZWTKJL": "Chưa có lịch sử hoàn tiền",
    "GDTKJL": "Xem thêm lịch sử hoàn tiền",
    "DDDKFQRBJQSH": "Đơn hàng chờ CS xác nhận báo giá, vui lòng chờ",
    "BNSRDYHDTSZF": "Không thể nhập ký tự đặc biệt như dấu nháy đơn",
    "THSLBNWK": "Số lượng trả hàng không thể để trống",
    "BZBNBHBQ": "Ghi chú không thể chứa biểu tượng cảm xúc",
    "THSLBKDYKTHSL": "Số lượng trả hàng lớn hơn số lượng có thể trả",
    "DDM_YZ_J": "Đơn hàng tặng {number} sản phẩm khi đủ {target} Yuan",
    "M_JZ_J": "Tặng {number} sản phẩm khi đủ {target} sản phẩm",
    "M_JJZ_Y": "Giảm至 {money} Yuan khi đủ {target} sản phẩm",
    "YDHJJZ_Y": "Giá đặt hàng gốc giảm至 {price} Yuan",
    "M_JD_Z": "Giảm {percent}折 khi đủ {number} sản phẩm",
    "YDHJD_Z": "Giá đặt hàng gốc giảm {percent}折",
    // Mercado Pago支付
    "WDSYT": "Quầy thu tiền của tôi",
    "ZZSYMPSMJY": "Đang sử dụng giao dịch quét QR Mercado Pago",
    "SKF": "Bên nhận tiền",
    "SYSFK": "Quét QR để thanh toán",
    "DDXQ": "Chi tiết đơn hàng",
    "YUAN": "Yuan",
    // 优惠券
    "GXNHQ_Z_Y_": "Chúc mừng bạn nhận được {num} phiếu {price} Yuan {name}",
    "QBLX": "Tất cả loại",
    "QLQZX": "Đi đến trung tâm nhận phiếu",
    "YLYH": "Đã nhận ưu đãi",
    "MZTJJKSY": "Có thể dùng khi đáp ứng điều kiện",
    "GXNHD_Z_YHQ": "Chúc mừng bạn nhận được {num} phiếu ưu đãi",
    "G_Y": "Tổng {price} Yuan",
    "XZYHQ": "Chọn phiếu ưu đãi",
    "PLXD": "Đặt hàng hàng loạt",
    "FHJL": "Lịch sử giao hàng",
    "DDTJ": "Thống kê đơn hàng",
    "DDGL": "Quản lý đơn hàng",
    "JKWFH": "Chỉ xem chưa giao hàng",
    "DDS": "Số đơn hàng",
    "DGSPS": "Số lượng sản phẩm đặt hàng",
    "THSPS": "Số lượng sản phẩm trả hàng",
    "YFHSPS": "Số lượng sản phẩm đã giao",
    "WFHSPS": "Số lượng sản phẩm chưa giao",
    "YFHSPJE": "Số tiền sản phẩm đã giao",
    "WFHSPJE": "Số tiền sản phẩm chưa giao",
    "WFH": "Chưa giao hàng",
    "YGJ": "Dự tính",
    "GGBM": "Mã quy cách",
    "SLHJ": "Tổng số lượng",
    "JEHJ": "Tổng số tiền",
    "QPLKY": "Có thể dùng cho tất cả danh mục",
    "KYCXHDDJSY": "Có thể叠加 dùng với hoạt động khuyến mãi",
    "BKDKYF": "Không thể trừ phí vận chuyển",
    "SYHBYTH": "Không hoàn lại sau khi sử dụng",
    "TiJi": "Thể tích",
    "ZhongLiang": "Trọng lượng",
    "ZongTiJi": "Tổng thể tích",
    "ZongZhongLiang": "Tổng trọng lượng",
    "QSRDHDCKDWLDHSJRSJH": "Vui lòng nhập số đơn hàng/số đơn xuất kho/số đơn logistics/người nhận/số điện thoại",
    "CKDH": "Số đơn xuất kho",
    "WLDZT": "Trạng thái đơn logistics",
    "WLDH": "Số đơn logistics",
    "SJR": "Người nhận",
};
export default vi_VN
